import React, { useEffect, useState } from "react";
import FacilitiesPdfExport from "./FacilitiesPdfExport";
import { NavLink } from "react-router-dom";
import { Building2, ClipboardList, FileText, Users, Search, Upload, Plus, X, Database, ChevronRight, Edit2, Trash2, Layers, CalendarOff, Download, ShieldCheck, GitBranch, ScrollText, History } from "lucide-react";
import { api, openDocumentBlob } from "../api";
import { Header } from "./Shell";
import { AlgorithmFlow } from "./AlgorithmsPage"; //Importa la funzione di visualizzazione flowchart dalla sezione degli operatori

export function Admin({section="overview", user}) {
  const isRealAdmin = user?.role === "admin";
  const userPermissions = user?.permissions || [];

const can = permission =>
  userPermissions.includes(permission);
  
  const [data,setData]=useState(null);
  const [users,setUsers]=useState([]);
  const [roles,setRoles]=useState([]); //Caricamento dei ruoli
const [permissions,setPermissions]=useState([]);
const [roleError,setRoleError]=useState("");
const [roleMessage,setRoleMessage]=useState("");
const emptyRole = {
  open: false,
  mode: "create",
  key: "",
  name: "",
  description: "",
  permissions: [],
  active: true
};

const [roleForm,setRoleForm]=useState(emptyRole);
const [savingRole,setSavingRole]=useState(false);

  const [facilities,setFacilities]=useState([]);
  const [docs,setDocs]=useState([]);
  const [audit,setAudit]=useState([]);
  const [auditSearchInput,setAuditSearchInput]=useState("");
  const [auditSearch,setAuditSearch]=useState("");
  const [auditPage,setAuditPage]=useState(1);
  const [auditMeta,setAuditMeta]=useState({total:0,page:1,pages:1});
  const [auditLoading,setAuditLoading]=useState(false);
  const [auditError,setAuditError]=useState("");
  const emptyUser={open:false,mode:"create",id:"",name:"",email:"",role:"operator",password:"",active:true,activation_mode:"email",activation_status:""};
  const emptyFacility={open:false,mode:"create",id:"",name:"",type:"Ospedale",address:"",city:"",province:"",phone:"",notes:"",active:true,latitude:"",longitude:""};
  const [userForm,setUserForm]=useState(emptyUser);
  const [facilityForm,setFacilityForm]=useState(emptyFacility);
  const [savingUser,setSavingUser]=useState(false);
  const [savingFacility,setSavingFacility]=useState(false);
  const [userError,setUserError]=useState("");
  const [userMessage,setUserMessage]=useState("");
  const [facilityError,setFacilityError]=useState("");
  const [facilityMessage,setFacilityMessage]=useState("");
const emptyAssignment={
  open:false,
  mode:"create",
  id:"",
  service_id:"",
  schedule:[
    {
      days:[0,1,2,3,4],
      start:"08:00",
      end:"20:00"
    }
  ],
  h24:false,
  notes:"",
  active:true
};
  const [serviceMgr,setServiceMgr]=useState({open:false,facility:null});
  const [assignments,setAssignments]=useState([]);
  const [allServices,setAllServices]=useState([]);
  const [assignmentForm,setAssignmentForm]=useState(emptyAssignment);
  const [savingAssignment,setSavingAssignment]=useState(false);
  const [assignmentError,setAssignmentError]=useState("");
  const [assignmentMessage,setAssignmentMessage]=useState("");
  const [expandedAssignment,setExpandedAssignment]=useState(null);
  const emptyException={start_date:"",end_date:"",reason:""};
  const [exceptionForm,setExceptionForm]=useState(emptyException);
  const [savingException,setSavingException]=useState(false);
  const [exceptionError,setExceptionError]=useState("");
  const emptyService={open:false,mode:"create",id:"",name:"",category:"Specialità",active:true};
  const [serviceForm,setServiceForm]=useState(emptyService);
  const [servicesCatalog,setServicesCatalog]=useState([]);
  const [savingService,setSavingService]=useState(false);
  const [serviceError,setServiceError]=useState("");
  const [serviceMessage,setServiceMessage]=useState("");
  const emptyDoc={open:false,mode:"edit",id:"",title:"",category:"",version:"",status:"active",description:"",identifier:""};
  const [docForm,setDocForm]=useState(emptyDoc);
  const [savingDoc,setSavingDoc]=useState(false);
  const [uploadingDocument,setUploadingDocument]=useState(false);
  const [docError,setDocError]=useState("");
  const [docMessage,setDocMessage]=useState("");
  const [ioMessage,setIoMessage]=useState("");
  const [ioError,setIoError]=useState("");
  const [facilityTypes,setFacilityTypes]=useState([]);
  const [facilityFilter,setFacilityFilter]=useState({q:"",type:"",province:""});
  const [facilitySort,setFacilitySort]=useState({column:"name",asc:true});
  const [typeMgrOpen,setTypeMgrOpen]=useState(false);
  const emptyType={open:false,mode:"create",id:"",name:"",active:true};
  const [typeForm,setTypeForm]=useState(emptyType);
  const [savingType,setSavingType]=useState(false);
  const [typeError,setTypeError]=useState("");
  const [typeMessage,setTypeMessage]=useState("");
  const [algorithms, setAlgorithms] = useState([]); // Stato degli algoritmi 
  const emptyAlgorithmForm = {
  number: "",
  title: "",
  document: "",
  attachment: "",
  revision: "",
  issue_date: "",
  application_date: "",
  status: "draft"
};
const [algorithmForm, setAlgorithmForm] = useState(emptyAlgorithmForm);
const [editingAlgorithm, setEditingAlgorithm] = useState(null);
const [showAlgorithmForm, setShowAlgorithmForm] = useState(false);
const [algorithmSaving, setAlgorithmSaving] = useState(false);
const [algorithmError, setAlgorithmError] = useState("");
// Editor flowchart algoritmi
const [flowEditor, setFlowEditor] = useState({
  open: false,
  algorithm: null,
  nodes: [],
  edges: []
});

const [flowLoading, setFlowLoading] = useState(false);
const [flowError, setFlowError] = useState("");
const [editingNode, setEditingNode] = useState(null); //Carica la funziona di modifica nodo flowchart
const [editingEdge, setEditingEdge] = useState(null); //Funzione di modifica di un collegamento flowchart
const [flowTool, setFlowTool] = useState("select");
const [flowLinkSource, setFlowLinkSource] = useState(null);

// Selezione grafica di collegamenti ed etichette.
// Gli indici si riferiscono alla copia locale flowEditor.edges.
const [selectedFlowEdgeIndex, setSelectedFlowEdgeIndex] = useState(null);
const [selectedFlowLabelIndex, setSelectedFlowLabelIndex] = useState(null);
const [selectedFlowPointIndex, setSelectedFlowPointIndex] = useState(null);
const [addingFlowPoint, setAddingFlowPoint] = useState(false);

// Menu contestuale delle etichette, in coordinate SVG.
const [flowEdgeContextMenu, setFlowEdgeContextMenu] = useState(null);
const [edgeError, setEdgeError] = useState(""); //Per gestire separatamenti gli errori della modifica di un nodo rispetto a quelli generali
const [flowSaving, setFlowSaving] = useState(false); //Funzione di salvataggio flowchart
const [flowSaved, setFlowSaved] = useState(false);
const [flowSaveMessage, setFlowSaveMessage] = useState(""); //Funzioni di salvataggio locale
const [flowSaveMessageType, setFlowSaveMessageType] = useState("");

  const DAY_LABELS=["Lun","Mar","Mer","Gio","Ven","Sab","Dom"];
  const loadUsers=()=>api.get("/admin/users").then(r=>setUsers(r.data));
  const loadRoles=()=>api.get("/admin/roles").then(r=>setRoles(r.data)); //Ruoli
const loadPermissions=()=>api.get("/admin/permissions").then(r=>setPermissions(r.data)); //Permessi
  const loadFacilities=()=>api.get("/facilities").then(r=>setFacilities(r.data));
  const loadDocs=()=>api.get("/documents").then(r=>setDocs(r.data));

  useEffect(()=>{
    const refreshDocuments=()=>loadDocs();
    window.addEventListener("documents:updated", refreshDocuments);
    return ()=>window.removeEventListener("documents:updated", refreshDocuments);
  },[]);
  useEffect(() => {
    const onUploadState = event => {
      setUploadingDocument(Boolean(event.detail?.uploading));
    };

    window.addEventListener("documents:upload-state", onUploadState);

    return () => {
      window.removeEventListener("documents:upload-state", onUploadState);
    };
  }, []);

  const submitAuditSearch = e => {
    e.preventDefault();
    setAuditPage(1);
    setAuditSearch(auditSearchInput.trim());
  };

  const resetAuditSearch = () => {
    setAuditSearchInput("");
    setAuditSearch("");
    setAuditPage(1);
  };
  const loadAlgorithms = () =>api.get("/admin/algorithms").then(r => setAlgorithms(r.data)); //Funzione caricamento algoritmi con bozze e archiviati
  const newAlgorithm = () => { //Crea nuovo algoritmo
  setEditingAlgorithm(null);
  setAlgorithmForm(emptyAlgorithmForm);
  setAlgorithmError("");
  setShowAlgorithmForm(true);
};

const editAlgorithm = (algorithm) => { //Modifica algoritmo
  setEditingAlgorithm(algorithm);

  setAlgorithmForm({
    number: algorithm.number ?? "",
    title: algorithm.title ?? "",
    document: algorithm.document ?? "",
    attachment: algorithm.attachment ?? "",
    revision: algorithm.revision ?? "",
    issue_date: algorithm.issue_date ?? "",
    application_date: algorithm.application_date ?? "",
    status: algorithm.status ?? "draft"
  });

  setAlgorithmError("");
  setShowAlgorithmForm(true);
};

const closeAlgorithmForm = () => {
  setShowAlgorithmForm(false);
  setEditingAlgorithm(null);
  setAlgorithmError("");
  setAlgorithmForm(emptyAlgorithmForm);
};

const saveAlgorithm = async (e) => {
  e.preventDefault();

  setAlgorithmError("");

  if (!algorithmForm.number || !algorithmForm.title.trim()) {
    setAlgorithmError(
      "Numero e titolo dell'algoritmo sono obbligatori."
    );
    return;
  };

 

  const payload = {
    ...algorithmForm,
    number: Number(algorithmForm.number),
    title: algorithmForm.title.trim()
  };

  try {
    setAlgorithmSaving(true);

    if (editingAlgorithm) {
      await api.put(
        `/admin/algorithms/${editingAlgorithm.id}`,
        payload
      );
    } else {
      await api.post(
        "/admin/algorithms",
        payload
      );
    }
    await loadAlgorithms();
    closeAlgorithmForm();
  } catch (err) {
    setAlgorithmError(
      err.response?.data?.detail ||
      "Errore durante il salvataggio dell'algoritmo."
    );
  } finally {
    setAlgorithmSaving(false);
  }
};

const deleteAlgorithm = async (algorithm) => { //Cancella algoritmo
  const confirmed = window.confirm(
    `Eliminare definitivamente l'Algoritmo n° ${algorithm.number}?\n\n` +
    `${algorithm.title}\n\n` +
    "Questa operazione non può essere annullata."
  );

  if (!confirmed) {
    return;
  }

  try {
    setAlgorithmError("");

    await api.delete(
      `/admin/algorithms/${algorithm.id}`
    );

    /*
     * Se per qualche motivo era aperto proprio
     * l'algoritmo eliminato, chiudiamo il form.
     */
    if (editingAlgorithm?.id === algorithm.id) {
      closeAlgorithmForm();
    }

    await loadAlgorithms();

  } catch (err) {
    setAlgorithmError(
      err.response?.data?.detail ||
      "Errore durante l'eliminazione dell'algoritmo."
    );
  }
}

const markFlowAsModified = () => { //Funzione per l'accorpamento dell'azzeramento dei messaggi di errore
  setFlowSaved(false);
  setFlowSaveMessage("");
  setFlowSaveMessageType("");
};

// Apre l'editor della flowchart e carica l'algoritmo completo
const openFlowEditor = async (algorithm) => {
  setFlowLoading(true);
  setFlowError("");
  setFlowTool("select");
  setFlowLinkSource(null);
  setSelectedFlowEdgeIndex(null);
  setSelectedFlowLabelIndex(null);
  setSelectedFlowPointIndex(null);
  setAddingFlowPoint(false);
  setFlowEdgeContextMenu(null);
  setEditingNode(null);
  setEditingEdge(null);
  setEdgeError("");

  try {
    const response = await api.get(
      `/admin/algorithms/${algorithm.id}`
    );

    setFlowEditor({
      open: true,
      algorithm: response.data,
      nodes: response.data.nodes || [],
      edges: response.data.edges || []
    });

    setFlowSaved(true);
setFlowSaveMessage("");
setFlowSaveMessageType("");

  } catch (err) {
    setFlowError(
      err.response?.data?.detail ||
      "Impossibile caricare la flowchart."
    );
  } finally {
    setFlowLoading(false);
  }
};

// Chiude l'editor della flowchart
const closeFlowEditor = () => {
  if (!flowSaved) {
    const confirmed = window.confirm(
      "Sono presenti modifiche alla flowchart non ancora salvate.\n\n" +
      "Chiudendo l'editor queste modifiche andranno perse.\n\n" +
      "Vuoi chiudere comunque?"
    );

    if (!confirmed) {
      return;
    }
  }

  setFlowEditor({
    open: false,
    algorithm: null,
    nodes: [],
    edges: []
  });

  setEditingNode(null);
  setEditingEdge(null);
  setEdgeError("");
  setFlowError("");
  setFlowTool("select");
  setFlowLinkSource(null);
  setSelectedFlowEdgeIndex(null);
  setSelectedFlowLabelIndex(null);
  setSelectedFlowPointIndex(null);
  setAddingFlowPoint(false);
  setFlowEdgeContextMenu(null);

  setFlowSaved(false);
setFlowSaveMessage("");
setFlowSaveMessageType("");
};

// Apre la modifica di un singolo nodo
const editFlowNode = (node) => {
  setEditingEdge(null);
  setEditingNode({
    ...node
  });
  setFlowError("");
};

// Chiude la modifica del nodo senza applicarla
const cancelFlowNodeEdit = () => {
  setEditingNode(null);
};

// Sposta il nodo in modifica di pochi pixel.
// La modifica resta temporanea in editingNode
// finché non viene premuto "Applica modifica".
const nudgeFlowNode = (deltaX, deltaY) => {
  setEditingNode(prev => {
    if (!prev) {
      return prev;
    }

    return {
      ...prev,
      x: Number(prev.x || 0) + deltaX,
      y: Number(prev.y || 0) + deltaY
    };
  });

  setFlowError("");
};

// Controlla l'intera flowchart prima del salvataggio nel database.
// Restituisce null se tutto è valido, altrimenti il messaggio di errore.
const validateFlowchart = () => {
  const nodes = flowEditor.nodes || [];
  const edges = flowEditor.edges || [];

  const validNodeTypes = new Set([
    "entry",
    "action",
    "criteria",
    "decision",
    "treatment",
    "warning",
    "exit"
  ]);

  const validSides = new Set([
    "top",
    "right",
    "bottom",
    "left"
  ]);

  // -------------------------------------------------------
  // NODI
  // -------------------------------------------------------

  const nodeIds = new Set();

  for (let index = 0; index < nodes.length; index += 1) {
    const node = nodes[index];
    const nodeNumber = index + 1;

    if (!node.id || !String(node.id).trim()) {
      return `Il nodo n° ${nodeNumber} non ha un ID valido.`;
    }

    const nodeId = String(node.id).trim();

    if (nodeIds.has(nodeId)) {
      return `L'ID nodo "${nodeId}" è duplicato.`;
    }

    nodeIds.add(nodeId);

    if (!validNodeTypes.has(node.type)) {
      return `Il nodo "${nodeId}" ha un tipo non valido: "${node.type}".`;
    }

    const x = Number(node.x);
    const y = Number(node.y);
    const width = Number(node.width);
    const height = Number(node.height);

    if (!Number.isFinite(x) || !Number.isFinite(y)) {
      return `Il nodo "${nodeId}" deve avere coordinate X e Y valide.`;
    }

    if (
      !Number.isFinite(width) ||
      !Number.isFinite(height) ||
      width <= 0 ||
      height <= 0
    ) {
      return `Il nodo "${nodeId}" deve avere larghezza e altezza maggiori di zero.`;
    }
  }

  // -------------------------------------------------------
  // COLLEGAMENTI
  // -------------------------------------------------------

  const edgeKeys = new Set();

  for (let index = 0; index < edges.length; index += 1) {
    const edge = edges[index];
    const edgeNumber = index + 1;

    if (!edge.source || !edge.target) {
      return `Il collegamento n° ${edgeNumber} deve avere origine e destinazione.`;
    }

    if (!nodeIds.has(edge.source)) {
      return (
        `Il collegamento n° ${edgeNumber} usa come origine ` +
        `un nodo inesistente: "${edge.source}".`
      );
    }

    if (!nodeIds.has(edge.target)) {
      return (
        `Il collegamento n° ${edgeNumber} usa come destinazione ` +
        `un nodo inesistente: "${edge.target}".`
      );
    }

    if (edge.source === edge.target) {
      return (
        `Il collegamento n° ${edgeNumber} collega il nodo ` +
        `"${edge.source}" a sé stesso.`
      );
    }

    // Stessa regola già utilizzata nell'editor:
    // origine + destinazione + etichetta.
    const edgeKey = JSON.stringify([
      edge.source,
      edge.target,
      (edge.label || "").trim()
    ]);

    if (edgeKeys.has(edgeKey)) {
      return (
        `Esiste un collegamento duplicato: ` +
        `"${edge.source}" → "${edge.target}"` +
        `${edge.label ? ` con etichetta "${edge.label}"` : ""}.`
      );
    }

    edgeKeys.add(edgeKey);

    if (
      edge.sourceSide !== undefined &&
      !validSides.has(edge.sourceSide)
    ) {
      return (
        `Il collegamento n° ${edgeNumber} ha un lato origine ` +
        `non valido: "${edge.sourceSide}".`
      );
    }

    if (
      edge.targetSide !== undefined &&
      !validSides.has(edge.targetSide)
    ) {
      return (
        `Il collegamento n° ${edgeNumber} ha un lato destinazione ` +
        `non valido: "${edge.targetSide}".`
      );
    }

    // -----------------------------------------------------
    // PUNTI INTERMEDI
    // -----------------------------------------------------

    if (edge.points !== undefined && !Array.isArray(edge.points)) {
      return (
        `I punti intermedi del collegamento n° ${edgeNumber} ` +
        `non sono validi.`
      );
    }

    for (
      let pointIndex = 0;
      pointIndex < (edge.points || []).length;
      pointIndex += 1
    ) {
      const point = edge.points[pointIndex];

      if (
        !Number.isFinite(Number(point.x)) ||
        !Number.isFinite(Number(point.y))
      ) {
        return (
          `Il punto P${pointIndex + 1} del collegamento n° ` +
          `${edgeNumber} deve avere coordinate X e Y valide.`
        );
      }
    }

    // -----------------------------------------------------
    // POSIZIONE MANUALE ETICHETTA
    // -----------------------------------------------------

    const hasLabelX = edge.labelX !== undefined;
    const hasLabelY = edge.labelY !== undefined;

    if (hasLabelX !== hasLabelY) {
      return (
        `Il collegamento n° ${edgeNumber} ha una posizione ` +
        `dell'etichetta incompleta: X e Y devono essere entrambe presenti.`
      );
    }

    if (
      hasLabelX &&
      (
        !Number.isFinite(Number(edge.labelX)) ||
        !Number.isFinite(Number(edge.labelY))
      )
    ) {
      return (
        `Il collegamento n° ${edgeNumber} ha coordinate ` +
        `dell'etichetta non valide.`
      );
    }
  }

  return null;
};

const saveFlowchart = async () => {
  if (!flowEditor.algorithm) {
    return;
  }

  setFlowSaveMessage("");
  setFlowSaveMessageType("");
  setFlowError("");

  // Impedisce di salvare una versione precedente mentre
  // un nodo o collegamento contiene modifiche non applicate.
  if (editingNode || editingEdge) {
    setFlowSaveMessage(
      "Prima di salvare la flowchart, premi 'Applica modifica' " +
      "oppure 'Annulla' nella modifica del nodo o collegamento aperta."
    );
    setFlowSaveMessageType("error");
    return;
  }

  const validationError = validateFlowchart();
  if (validationError) {
  setFlowSaveMessage(
    `Impossibile salvare la flowchart: ${validationError}`
  );
  setFlowSaveMessageType("error");
  return;
}

  const confirmed = window.confirm(
    `Salvare le modifiche alla flowchart dell'Algoritmo n° ${flowEditor.algorithm.number}?\n\n` +
    "Le modifiche verranno registrate nel database."
  );

  if (!confirmed) {
    return;
  }

  try {
    setFlowSaving(true);
    setFlowError("");

    await api.put(
      `/admin/algorithms/${flowEditor.algorithm.id}/flow`,
      {
        nodes: flowEditor.nodes,
        edges: flowEditor.edges
      }
    );

    setFlowSaved(true);
setFlowSaveMessage("Flowchart salvata correttamente.");
setFlowSaveMessageType("success");

  } catch (err) {
  console.error("Errore salvataggio flowchart:", err);
  console.error("Risposta backend:", err.response?.data);
  console.error("Status HTTP:", err.response?.status);

  const detail = err.response?.data?.detail;

  setFlowSaveMessage(
  detail
    ? typeof detail === "string"
      ? detail
      : JSON.stringify(detail)
    : err.message ||
      "Errore durante il salvataggio della flowchart."
);

setFlowSaveMessageType("error");
} finally {
    setFlowSaving(false);
  }
};
// Crea un nuovo nodo nella copia locale della flowchart.
// Il database NON viene modificato fino a "Salva flowchart".
const addFlowNode = () => {
  setEditingEdge(null);
  const existingIds = new Set(
    flowEditor.nodes.map(node => node.id)
  );

  let counter = flowEditor.nodes.length + 1;
  let newId = `node_${counter}`;

  while (existingIds.has(newId)) {
    counter += 1;
    newId = `node_${counter}`;
  }

  const newNode = {
    id: newId,
    type: "action",
    text: "Nuovo nodo",
    x: 50,
    y: 50,
    width: 260,
    height: 100
  };

  setFlowEditor(prev => ({
    ...prev,
    nodes: [...prev.nodes, newNode]
  }));

  // Apriamo immediatamente il nuovo nodo nell'editor
  setEditingNode({
    ...newNode
  });

  setFlowError("");
  markFlowAsModified();
};

// Elimina un nodo dalla copia locale della flowchart.
// Se il nodo è usato da uno o più collegamenti, l'eliminazione viene bloccata.
const deleteFlowNode = (node) => {
  const connectedEdges = flowEditor.edges.filter(
    edge =>
      edge.source === node.id ||
      edge.target === node.id
  );

  if (connectedEdges.length > 0) {
    setFlowError(
      `Impossibile eliminare il nodo "${node.id}": ` +
      `è utilizzato da ${connectedEdges.length} ` +
      `${connectedEdges.length === 1 ? "collegamento" : "collegamenti"}.`
    );

    return;
  }

  const confirmed = window.confirm(
    `Eliminare il nodo "${node.id}"?\n\n` +
    `${node.text || ""}\n\n` +
    "Il nodo verrà eliminato dalla copia locale della flowchart. " +
    "La modifica diventerà definitiva solo premendo \"Salva flowchart\"."
  );

  if (!confirmed) {
    return;
  }

  setFlowEditor(prev => ({
    ...prev,
    nodes: prev.nodes.filter(
      currentNode => currentNode.id !== node.id
    )
  }));

  // Se stavamo modificando proprio questo nodo,
  // chiudiamo anche il relativo form.
  if (editingNode?.id === node.id) {
    setEditingNode(null);
  }

  setFlowError("");
  markFlowAsModified();
};

// Applica la modifica solo localmente. 
// NON salva ancora nulla nel database.
const applyFlowNodeEdit = () => {
  if (!editingNode) {
    return;
  }

  if (!editingNode.id?.trim()) {
    setFlowError("L'ID del nodo è obbligatorio.");
    return;
  }

  setFlowEditor(prev => ({
    ...prev,
    nodes: prev.nodes.map(node =>
      node.id === editingNode.id
        ? { ...editingNode }
        : node
    )
  }));

  setEditingNode(null);
  setFlowError("");
  markFlowAsModified();
};

// Apre la modifica di un collegamento.
// Salviamo anche l'indice per identificare esattamente l'edge.
const editFlowEdge = (edge, index) => {
  setEditingNode(null);
  setEditingEdge({
    ...edge,
    _index: index
  });

  setEdgeError("");
};


// Annulla la modifica del collegamento
const cancelFlowEdgeEdit = () => {
  setEditingEdge(null);
  setEdgeError("");
};


// Applica la modifica solo alla copia locale.
// MongoDB NON viene ancora modificato.
const applyFlowEdgeEdit = () => {
  if (!editingEdge) {
    return;
  }

  if (!editingEdge.source || !editingEdge.target) {
    setEdgeError(
      "Origine e destinazione del collegamento sono obbligatorie."
    );
    return;
  }

  if (editingEdge.source === editingEdge.target) {
    setEdgeError(
      "Origine e destinazione non possono essere lo stesso nodo."
    );
    return;
  }

  const duplicateEdge = flowEditor.edges.some(
  (edge, index) =>
    index !== editingEdge._index &&
    edge.source === editingEdge.source &&
    edge.target === editingEdge.target &&
    (edge.label || "").trim() ===
      (editingEdge.label || "").trim()
);

if (duplicateEdge) {
  setEdgeError(
    "Esiste già un collegamento identico con la stessa origine, destinazione ed etichetta."
  );
  return;
}
// Converte e valida le coordinate dei punti intermedi
const normalizedPoints = [];

for (let pointIndex = 0; pointIndex < (editingEdge.points || []).length; pointIndex += 1) {
  const point = editingEdge.points[pointIndex];

  const x = Number(point.x);
  const y = Number(point.y);

  if (
    point.x === "" ||
    point.y === "" ||
    !Number.isFinite(x) ||
    !Number.isFinite(y)
  ) {
    setEdgeError(
      `Il punto P${pointIndex + 1} deve avere coordinate X e Y valide.`
    );
    return;
  }

  normalizedPoints.push({
    ...point,
    x,
    y
  });
}
  const edgeIndex = editingEdge._index;

  // _index serve solo all'editor e non deve finire nel database.
  const {
  _index,
  ...edgeWithoutIndex
} = editingEdge;

if (
  editingEdge.labelX !== undefined &&
  editingEdge.labelY !== undefined &&
  (
    editingEdge.labelX === "" ||
    editingEdge.labelY === "" ||
    !Number.isFinite(Number(editingEdge.labelX)) ||
    !Number.isFinite(Number(editingEdge.labelY))
  )
) {
  setEdgeError(
    "Le coordinate X e Y dell'etichetta devono essere valide."
  );
  return;
}

const updatedEdge = {
  ...edgeWithoutIndex,

  ...(edgeWithoutIndex.labelX !== undefined &&
     edgeWithoutIndex.labelY !== undefined
    ? {
        labelX: Number(edgeWithoutIndex.labelX),
        labelY: Number(edgeWithoutIndex.labelY)
      }
    : {}),

  points: normalizedPoints
};

  setFlowEditor(prev => ({
    ...prev,
    edges: prev.edges.map((edge, index) =>
      index === edgeIndex
        ? updatedEdge
        : edge
    )
  }));

  setEditingEdge(null);
  setEdgeError("");
  markFlowAsModified();
};

// Crea collegamenti selezionando due nodi direttamente sulla flowchart.
const handleFlowNodeClick = (nodeId) => {
  if (flowTool !== "connect" || flowSaving) return;

  if (!flowLinkSource) {
    setFlowLinkSource(nodeId);
    setFlowError("");
    return;
  }

  if (flowLinkSource === nodeId) {
    setFlowLinkSource(null);
    setFlowError("Origine e destinazione devono essere nodi diversi.");
    return;
  }

  const source = flowLinkSource;
  const target = nodeId;

  const duplicate = flowEditor.edges.some(edge =>
    edge.source === source &&
    edge.target === target &&
    (edge.label || "").trim() === ""
  );

  if (duplicate) {
    setFlowLinkSource(null);
    setFlowError("Questo collegamento senza etichetta esiste già.");
    return;
  }

  setFlowEditor(prev => ({
    ...prev,
    edges: [
      ...prev.edges,
      {
        source,
        target,
        sourceSide: "bottom",
        targetSide: "top",
        label: "",
        points: []
      }
    ]
  }));

  setFlowLinkSource(null);
  setSelectedFlowEdgeIndex(null);
  setSelectedFlowLabelIndex(null);
  setSelectedFlowPointIndex(null);
  setAddingFlowPoint(false);
  setFlowEdgeContextMenu(null);
  setFlowError("");
  markFlowAsModified();
};

// Crea un nuovo collegamento nella copia locale della flowchart.
// Il database NON viene modificato fino a "Salva flowchart".
const addFlowEdge = () => {
  if (flowEditor.nodes.length < 2) {
    setFlowError(
      "Servono almeno due nodi per creare un collegamento."
    );
    return;
  }

  setEditingNode(null);

  const newEdge = {
    source: flowEditor.nodes[0].id,
    target: flowEditor.nodes[1].id,
    label: "",
    points: []
  };

  const newIndex = flowEditor.edges.length;

  setFlowEditor(prev => ({
    ...prev,
    edges: [...prev.edges, newEdge]
  }));

  // Rimuoviamo selezioni precedenti, poi apriamo il nuovo collegamento.
  setSelectedFlowEdgeIndex(null);
  setSelectedFlowLabelIndex(null);
  setSelectedFlowPointIndex(null);
  setAddingFlowPoint(false);
  setFlowEdgeContextMenu(null);
  setEditingEdge({
    ...newEdge,
    _index: newIndex
  });

  setFlowError("");
  markFlowAsModified();
};

// Elimina un collegamento dalla copia locale della flowchart.
// Il database NON viene modificato fino a "Salva flowchart".
const deleteFlowEdge = (edge, index) => {
  const labelText = edge.label
    ? `\nEtichetta: ${edge.label}`
    : "";

  const confirmed = window.confirm(
    `Eliminare questo collegamento?\n\n` +
    `${edge.source} → ${edge.target}` +
    `${labelText}\n\n` +
    "Il collegamento verrà eliminato dalla copia locale della flowchart. " +
    "La modifica diventerà definitiva solo premendo \"Salva flowchart\"."
  );

  if (!confirmed) {
    return;
  }

  setFlowEditor(prev => ({
    ...prev,
    edges: prev.edges.filter(
      (_, currentIndex) => currentIndex !== index
    )
  }));

  setSelectedFlowEdgeIndex(null);
  setSelectedFlowLabelIndex(null);
  setSelectedFlowPointIndex(null);
  setAddingFlowPoint(false);
  setFlowEdgeContextMenu(null);

  // Gli indici degli edge possono cambiare dopo un'eliminazione.
// Chiudiamo quindi qualsiasi form di modifica aperto.
setEditingEdge(null);
setEdgeError("");

  setFlowError("");
  markFlowAsModified();
};

// Modifica una coordinata di un punto intermedio
const updateEdgePoint = (pointIndex, field, value) => {
  setEditingEdge(prev => ({
    ...prev,
    points: (prev.points || []).map((point, index) =>
      index === pointIndex
        ? {
            ...point,
            [field]: value
          }
        : point
    )
  }));

  setEdgeError("");
};


// Aggiunge un nuovo punto intermedio in una posizione iniziale intuitiva
const addEdgePoint = () => {
  if (!editingEdge) {
    return;
  }

  const sourceNode = flowEditor.nodes.find(
    node => node.id === editingEdge.source
  );

  const targetNode = flowEditor.nodes.find(
    node => node.id === editingEdge.target
  );

  if (!sourceNode || !targetNode) {
    setEdgeError(
      "Impossibile determinare la posizione dei nodi origine e destinazione."
    );
    return;
  }

  /*
   * Calcoliamo il centro dei due nodi.
   * Se width/height non fossero presenti, utilizziamo 0.
   */
  const sourceCenterX =
    Number(sourceNode.x || 0) +
    Number(sourceNode.width || 0) / 2;

  const sourceCenterY =
    Number(sourceNode.y || 0) +
    Number(sourceNode.height || 0) / 2;

  const targetCenterX =
    Number(targetNode.x || 0) +
    Number(targetNode.width || 0) / 2;

  const targetCenterY =
    Number(targetNode.y || 0) +
    Number(targetNode.height || 0) / 2;

  /*
   * Il nuovo punto viene inizialmente posizionato
   * a metà strada tra origine e destinazione.
   */
  const newPoint = {
    x: Math.round((sourceCenterX + targetCenterX) / 2),
    y: Math.round((sourceCenterY + targetCenterY) / 2)
  };

  setEditingEdge(prev => ({
    ...prev,
    points: [
      ...(prev.points || []),
      newPoint
    ]
  }));

  setEdgeError("");
};


// Elimina un punto intermedio
const deleteEdgePoint = (pointIndex) => {
  setEditingEdge(prev => ({
    ...prev,
    points: (prev.points || []).filter(
      (_, index) => index !== pointIndex
    )
  }));

  setEdgeError("");
};

// Sposta un punto intermedio avanti o indietro
// nell'ordine seguito dal collegamento.
const moveEdgePoint = (pointIndex, direction) => {
  setEditingEdge(prev => {
    if (!prev) {
      return prev;
    }

    const points = [...(prev.points || [])];

    const newIndex =
      direction === "up"
        ? pointIndex - 1
        : pointIndex + 1;

    // Impedisce di uscire dai limiti dell'array.
    if (
      newIndex < 0 ||
      newIndex >= points.length
    ) {
      return prev;
    }

    // Scambia i due punti.
    [points[pointIndex], points[newIndex]] = [
      points[newIndex],
      points[pointIndex]
    ];

    return {
      ...prev,
      points
    };
  });

  setEdgeError("");
};

// Sposta leggermente un punto intermedio
// senza modificarne l'ordine nel percorso.
const nudgeEdgePoint = (pointIndex, deltaX, deltaY) => {
  setEditingEdge(prev => {
    if (!prev) {
      return prev;
    }

    const points = (prev.points || []).map((point, index) => {
      if (index !== pointIndex) {
        return point;
      }

      return {
        ...point,
        x: Number(point.x || 0) + deltaX,
        y: Number(point.y || 0) + deltaY
      };
    });

    return {
      ...prev,
      points
    };
  });

  setEdgeError("");
};

  const loadServicesCatalog=()=>api.get("/services").then(r=>setServicesCatalog(r.data));
  const loadFacilityTypes=()=>api.get("/facility-types").then(r=>setFacilityTypes(r.data));
 useEffect(()=>{
  const hasPermission = permission =>
    user?.permissions?.includes(permission);

  if(section==="overview" && hasPermission("admin.dashboard.read")){
    api.get("/dashboard").then(r=>setData(r.data));
  }

  if(section==="facilities" && hasPermission("admin.facilities.read")){
    loadFacilities();
    loadFacilityTypes();
  }

  if(section==="documents" && hasPermission("admin.documents.read")){
    loadDocs();
  }

  if(section==="users" && hasPermission("admin.users.read")){
    loadUsers();

    if(
      hasPermission("admin.roles.read") ||
      hasPermission("admin.users.write")
    ){
      loadRoles();
    }
  }

  if(section==="roles" && hasPermission("admin.roles.read")){
    loadRoles();
    loadPermissions();
  }

  // Il registro Audit viene caricato dall'effetto dedicato.

  if(section==="services" && hasPermission("admin.services.read")){
    loadServicesCatalog();
  }

  if(section==="algorithms" && hasPermission("admin.algorithms.read")){
    loadAlgorithms();
  }
},[section, user?.permissions]);

  useEffect(()=>{
    if(section!=="audit" || !user?.permissions?.includes("admin.audit.read")) return;

    let cancelled=false;
    setAuditLoading(true);
    setAuditError("");

    api.get("/admin/audit",{
      params:{
        page:auditPage,
        page_size:20,
        search:auditSearch
      }
    }).then(response=>{
      if(cancelled) return;
      const result=response.data;
      setAudit(result.items || []);
      setAuditMeta({
        total:result.total || 0,
        page:result.page || 1,
        pages:result.pages || 1
      });
      if(result.page && result.page!==auditPage){
        setAuditPage(result.page);
      }
    }).catch(error=>{
      if(cancelled) return;
      setAudit([]);
      setAuditError(
        error.response?.data?.detail ||
        "Impossibile caricare il registro Audit."
      );
    }).finally(()=>{
      if(!cancelled) setAuditLoading(false);
    });

    return ()=>{cancelled=true;};
  },[section,user?.permissions,auditPage,auditSearch]);


// PASSAGGIO 3
const toggleRolePermission=permission=>{
  if(!isRealAdmin && !userPermissions.includes(permission)) return;
  setRoleForm(prev=>({
    ...prev,
    permissions:prev.permissions.includes(permission)
      ? prev.permissions.filter(p=>p!==permission)
      : [...prev.permissions,permission]
  }));
};


// PASSAGGIO 4
const submitRole=async e=>{
  e.preventDefault();
  setRoleError("");
  setRoleMessage("");

  if(!roleForm.name.trim()){
    setRoleError("Inserisci il nome del ruolo.");
    return;
  }

  if(roleForm.mode==="create"&&!roleForm.key.trim()){
    setRoleError("Inserisci la chiave del ruolo.");
    return;
  }

  setSavingRole(true);

  try{
    if(roleForm.mode==="create"){
      await api.post("/admin/roles",{
        key:roleForm.key.trim().toLowerCase(),
        name:roleForm.name.trim(),
        description:roleForm.description.trim(),
        permissions:roleForm.permissions,
        active:roleForm.active
      });

      setRoleMessage(`Ruolo "${roleForm.name.trim()}" creato.`);
    }else{
      await api.put(`/admin/roles/${roleForm.key}`,{
        name:roleForm.name.trim(),
        description:roleForm.description.trim(),
        permissions:roleForm.permissions,
        active:roleForm.active
      });

      setRoleMessage(`Ruolo "${roleForm.name.trim()}" aggiornato.`);
    }

    setRoleForm(emptyRole);
    await loadRoles();

  }catch(error){
    setRoleError(
      error.response?.data?.detail ||
      "Operazione sul ruolo non riuscita."
    );
  }finally{
    setSavingRole(false);
  }
};

const deleteRole=async role=>{
  if(role.system) return;

  if(!window.confirm(`Eliminare il ruolo "${role.name}"?`)) return;

  setRoleError("");
  setRoleMessage("");

  try{
    await api.delete(`/admin/roles/${role.key}`);
    setRoleMessage(`Ruolo "${role.name}" eliminato.`);
    await loadRoles();
  }catch(error){
    setRoleError(
      error.response?.data?.detail ||
      "Eliminazione del ruolo non riuscita."
    );
  }
};

  const openCreateUser=()=>{setUserForm({...emptyUser,open:true});setUserError("");setUserMessage("")};
  const openEditUser=u=>{if(!isRealAdmin && u.role==="admin")return;setUserForm({open:true,mode:"edit",id:u.id,name:u.name,email:u.email,role:u.role,password:"",active:u.active,activation_mode:"manual",activation_status:u.activation_status||""});setUserError("");setUserMessage("")};
  //Funzioni CRUD ruoli
  const openCreateRole=()=>{
  setRoleForm({...emptyRole,open:true});
  setRoleError("");
  setRoleMessage("");
};

const openEditRole=role=>{
  setRoleForm({
    open:true,
    mode:"edit",
    key:role.key,
    name:role.name,
    description:role.description||"",
    permissions:[...(role.permissions||[])],
    active:role.active!==false
  });
  setRoleError("");
  setRoleMessage("");
};

const closeRoleForm=()=>{
  setRoleForm(prev=>({...prev,open:false}));
  setRoleError("");
};

const updateRoleField=(key,value)=>{
  setRoleForm(prev=>({...prev,[key]:value}));
};

  const closeUserForm=()=>{setUserForm(prev=>({...prev,open:false}));setUserError("")};
  const updateUserField=(k,v)=>setUserForm(prev=>({...prev,[k]:v}));
  const submitUser=async e=>{
    e.preventDefault();
    setUserError("");
    setUserMessage("");

    const creating = userForm.mode==="create";
    const pending = userForm.activation_status==="pending";
    const manual = userForm.activation_mode==="manual";
    const activating = !creating && pending && userForm.active;

    if((creating && manual || activating) && !userForm.password){
      setUserError("Per l'attivazione manuale è necessaria una password iniziale.");
      return;
    }

    if(userForm.password && (
      userForm.password.length<8 ||
      new TextEncoder().encode(userForm.password).length>72
    )){
      setUserError("La password deve contenere almeno 8 caratteri e non superare 72 byte.");
      return;
    }

    setSavingUser(true);

    try{
      if(creating){
        const body={
          name:userForm.name.trim(),
          email:userForm.email.trim().toLowerCase(),
          role:userForm.role,
          activation_mode:userForm.activation_mode
        };

        if(manual){
          body.password=userForm.password;
        }

        const response=await api.post("/admin/users",body);

        if(manual){
          setUserMessage(`Account creato e attivato per ${body.email}.`);
        }else if(response.data.email_sent){
          setUserMessage(`Account creato per ${body.email}. Email di attivazione inviata.`);
        }else{
          setUserError(`Account creato per ${body.email}, ma l'email di attivazione non è stata inviata.`);
        }
      }else{
        const body={
          name:userForm.name.trim(),
          role:userForm.role,
          active:userForm.active
        };

        if(userForm.password){
          body.password=userForm.password;
        }

        await api.put(`/admin/users/${userForm.id}`,body);

        setUserMessage(
          activating
            ? `Account attivato manualmente per ${userForm.email}.`
            : `Modifiche salvate per ${userForm.email}.`
        );
      }

      setUserForm(emptyUser);
      loadUsers();

    }catch(error){
      setUserError(error.response?.data?.detail||"Operazione non riuscita");
    }finally{
      setSavingUser(false);
    }
  };

  const resendActivation=async u=>{
    if(!window.confirm(
      `Inviare un nuovo link di attivazione a ${u.email}?\\n\\n`+
      "Il precedente collegamento verrà invalidato."
    )) return;

    setUserError("");
    setUserMessage("");

    try{
      const response=await api.post(
        `/admin/users/${u.id}/resend-activation`
      );

      if(response.data.email_sent){
        setUserMessage(
          `Nuova email di attivazione inviata a ${u.email}.`
        );
      }else{
        setUserError(
          `Il link è stato rigenerato, ma l'email a ${u.email} non è stata inviata.`
        );
      }

      loadUsers();
    }catch(error){
      setUserError(
        error.response?.data?.detail ||
        "Impossibile reinviare l'email di attivazione."
      );
    }
  };

  const cancelActivation=async u=>{
    if(!window.confirm(
      `Annullare l'attivazione dell'account ${u.email}?\\n\\n`+
      "Il collegamento email verrà invalidato e l'account resterà disabilitato."
    )) return;

    setUserError("");
    setUserMessage("");

    try{
      await api.post(`/admin/users/${u.id}/cancel-activation`);

      setUserMessage(
        `Attivazione annullata per ${u.email}.`
      );

      loadUsers();

    }catch(error){
      setUserError(
        error.response?.data?.detail ||
        "Impossibile annullare l'attivazione."
      );
    }
  };

  const toggleUser=async id=>{setUserError("");setUserMessage("");try{await api.patch(`/admin/users/${id}/toggle`);loadUsers()}catch(error){setUserError(error.response?.data?.detail||"Operazione non riuscita")}};
  const revokeAllSessions=async ()=>{
    if(!window.confirm(
      "Revocare tutte le sessioni attive?\n\n" +
      "Tutti gli utenti, incluso il tuo account, dovranno effettuare nuovamente l’accesso."
    )) return;

    setUserError("");
    setUserMessage("");

    try{
      await api.post("/admin/users/revoke-all-sessions");
      setUserMessage("Tutte le sessioni attive sono state revocate.");
    }catch(error){
      setUserError(
        error.response?.data?.detail ||
        "Impossibile revocare le sessioni"
      );
    }
  };

  const deleteUser=async u=>{
    if(!window.confirm(`Eliminare definitivamente l’account ${u.email}?`)) return;
    setUserError("");setUserMessage("");
    try{await api.delete(`/admin/users/${u.id}`);setUserMessage(`Account ${u.email} eliminato.`);loadUsers()}
    catch(error){setUserError(error.response?.data?.detail||"Eliminazione non riuscita")}
  };
  const openCreateFacility=()=>{setFacilityForm({...emptyFacility,open:true});setFacilityError("");setFacilityMessage("")};
  const openEditFacility=f=>{setFacilityForm({open:true,mode:"edit",id:f.id,name:f.name||"",type:f.type||"Ospedale",address:f.address||"",city:f.city||"",province:f.province||"",phone:f.phone||"",notes:f.notes||"",active:f.active!==false,latitude:f.latitude??"",longitude:f.longitude??""});setFacilityError("");setFacilityMessage("")};
  const closeFacilityForm=()=>{setFacilityForm(prev=>({...prev,open:false}));setFacilityError("")};
  const updateFacilityField=(k,v)=>setFacilityForm(prev=>({...prev,[k]:v}));
  const submitFacility=async e=>{
    e.preventDefault();setFacilityError("");setFacilityMessage("");
    if(!facilityForm.name.trim()){setFacilityError("Il nome è obbligatorio.");return}

    const latText=String(facilityForm.latitude??"").trim();
    const lonText=String(facilityForm.longitude??"").trim();

    if(Boolean(latText)!==Boolean(lonText)){
      setFacilityError("Inserisci entrambe le coordinate oppure lasciale entrambe vuote.");
      return;
    }

    const latitude=latText===""?null:Number(latText);
    const longitude=lonText===""?null:Number(lonText);

    if(latitude!==null&&(!Number.isFinite(latitude)||latitude < -90||latitude > 90)){
      setFacilityError("Latitudine non valida: inserisci un valore tra -90 e 90.");
      return;
    }

    if(longitude!==null&&(!Number.isFinite(longitude)||longitude < -180||longitude > 180)){
      setFacilityError("Longitudine non valida: inserisci un valore tra -180 e 180.");
      return;
    }
    setSavingFacility(true);
    const body={name:facilityForm.name.trim(),type:facilityForm.type,address:facilityForm.address,city:facilityForm.city,province:facilityForm.province.toUpperCase(),phone:facilityForm.phone,notes:facilityForm.notes,active:facilityForm.active,latitude,longitude};
    try{
      if(facilityForm.mode==="create"){await api.post("/admin/facilities",body);setFacilityMessage(`Struttura "${body.name}" creata.`)}
      else{await api.put(`/admin/facilities/${facilityForm.id}`,body);setFacilityMessage(`Modifiche salvate per "${body.name}".`)}
      setFacilityForm(emptyFacility);loadFacilities();
    }catch(error){setFacilityError(error.response?.data?.detail||"Operazione non riuscita")}
    finally{setSavingFacility(false)}
  };
  const deleteFacility=async f=>{
    if(!window.confirm(`Eliminare la struttura "${f.name}"? Verrà rimossa anche la disponibilità associata.`)) return;
    setFacilityError("");setFacilityMessage("");
    try{await api.delete(`/admin/facilities/${f.id}`);setFacilityMessage(`Struttura "${f.name}" eliminata.`);loadFacilities()}
    catch(error){setFacilityError(error.response?.data?.detail||"Eliminazione non riuscita")}
  };
  const openServiceMgr=async f=>{
    setServiceMgr({open:true,facility:f});setAssignmentForm(emptyAssignment);setAssignmentError("");setAssignmentMessage("");
    try{
      const [ass,all]=await Promise.all([api.get(`/admin/facilities/${f.id}/services`),api.get("/services")]);
      setAssignments(ass.data);setAllServices(all.data);
    }catch(error){setAssignmentError(error.response?.data?.detail||"Impossibile caricare i servizi")}
  };
  const closeServiceMgr=()=>{setServiceMgr({open:false,facility:null});setAssignments([]);setAssignmentForm(emptyAssignment);setAssignmentError("");setAssignmentMessage("")};
  const reloadAssignments=async()=>{const r=await api.get(`/admin/facilities/${serviceMgr.facility.id}/services`);setAssignments(r.data)};
  const openAddAssignment=()=>{setAssignmentForm({...emptyAssignment,open:true,mode:"create"});setAssignmentError("");setAssignmentMessage("")};
const openEditAssignment=a=>{
  const schedule =
    Array.isArray(a.schedule) && a.schedule.length
      ? a.schedule.map(slot=>({
          days:slot.days||[],
          start:slot.start||"08:00",
          end:slot.end||"20:00"
        }))
      : [{
          days:a.days||[],
          start:a.start||"08:00",
          end:a.end||"20:00"
        }];

  setAssignmentForm({
    open:true,
    mode:"edit",
    id:a.id,
    service_id:a.service_id,
    schedule,
    h24:!!a.h24,
    notes:a.notes||"",
    active:a.active!==false
  });

  setAssignmentError("");
  setAssignmentMessage("");
};
  const closeAssignmentForm=()=>{setAssignmentForm(prev=>({...prev,open:false}));setAssignmentError("")};
  const updateAssignField=(k,v)=>
  setAssignmentForm(prev=>({...prev,[k]:v}));

const updateTimeSlot=(index,field,value)=>{
  setAssignmentForm(prev=>({
    ...prev,
    schedule:prev.schedule.map((slot,i)=>
      i===index ? {...slot,[field]:value} : slot
    )
  }));
};

const toggleSlotDay=(index,day)=>{
  setAssignmentForm(prev=>({
    ...prev,
    schedule:prev.schedule.map((slot,i)=>{
      if(i!==index) return slot;

      const days=slot.days.includes(day)
        ? slot.days.filter(d=>d!==day)
        : [...slot.days,day].sort((a,b)=>a-b);

      return {...slot,days};
    })
  }));
};

const addTimeSlot=()=>{
  setAssignmentForm(prev=>({
    ...prev,
    schedule:[
      ...prev.schedule,
      {
        days:[0,1,2,3,4],
        start:"08:00",
        end:"20:00"
      }
    ]
  }));
};

const removeTimeSlot=index=>{
  setAssignmentForm(prev=>({
    ...prev,
    schedule:prev.schedule.filter((_,i)=>i!==index)
  }));
};

const submitAssignment=async e=>{
  e.preventDefault();
  setAssignmentError("");
  setAssignmentMessage("");

  if(!assignmentForm.service_id){
    setAssignmentError("Seleziona un servizio dall’anagrafica.");
    return;
  }

  if(!assignmentForm.h24){
    if(!assignmentForm.schedule.length){
      setAssignmentError("Aggiungi almeno una fascia oraria oppure abilita H24.");
      return;
    }

    for(let i=0;i<assignmentForm.schedule.length;i++){
      const slot=assignmentForm.schedule[i];

      if(!slot.days.length){
        setAssignmentError(`Seleziona almeno un giorno nella fascia ${i+1}.`);
        return;
      }

      if(!slot.start || !slot.end){
        setAssignmentError(`Inserisci orario di inizio e fine nella fascia ${i+1}.`);
        return;
      }

      if(slot.start>=slot.end){
        setAssignmentError(
          `Nella fascia ${i+1} l’orario di fine deve essere successivo a quello di inizio.`
        );
        return;
      }
    }
  }

  setSavingAssignment(true);

  const schedule=assignmentForm.h24
    ? []
    : assignmentForm.schedule.map(slot=>({
        days:slot.days,
        start:slot.start,
        end:slot.end
      }));

  /*
   * Manteniamo anche days/start/end per compatibilità
   * con i record e il codice legacy.
   */
  const firstSlot=schedule[0]||{
    days:[0,1,2,3,4,5,6],
    start:"00:00",
    end:"23:59"
  };

  const body={
    service_id:assignmentForm.service_id,
    days:assignmentForm.h24
      ? [0,1,2,3,4,5,6]
      : firstSlot.days,
    start:assignmentForm.h24
      ? "00:00"
      : firstSlot.start,
    end:assignmentForm.h24
      ? "23:59"
      : firstSlot.end,
    schedule,
    h24:assignmentForm.h24,
    notes:assignmentForm.notes,
    active:assignmentForm.active
  };

  try{
    if(assignmentForm.mode==="create"){
      await api.post(
        `/admin/facilities/${serviceMgr.facility.id}/services`,
        body
      );
      setAssignmentMessage("Servizio associato alla struttura.");
    }else{
      const {service_id,...upd}=body;

      await api.put(
        `/admin/facilities/${serviceMgr.facility.id}/services/${assignmentForm.id}`,
        upd
      );
      setAssignmentMessage("Modifiche salvate.");
    }

    setAssignmentForm(emptyAssignment);
    await reloadAssignments();

  }catch(error){
    setAssignmentError(
      error.response?.data?.detail||
      "Operazione non riuscita"
    );
  }finally{
    setSavingAssignment(false);
  }
};

  const toggleAssignmentActive=async a=>{
    setAssignmentError("");setAssignmentMessage("");
    try{await api.put(`/admin/facilities/${serviceMgr.facility.id}/services/${a.id}`,{active:!(a.active!==false)});await reloadAssignments()}
    catch(error){setAssignmentError(error.response?.data?.detail||"Operazione non riuscita")}
  };
  const deleteAssignment=async a=>{
    if(!window.confirm(`Rimuovere il servizio "${a.service_name}" da ${serviceMgr.facility.name}?`)) return;
    setAssignmentError("");setAssignmentMessage("");
    try{await api.delete(`/admin/facilities/${serviceMgr.facility.id}/services/${a.id}`);setAssignmentMessage("Servizio rimosso dalla struttura.");await reloadAssignments()}
    catch(error){setAssignmentError(error.response?.data?.detail||"Operazione non riuscita")}
  };
  const toggleExpandAssignment=id=>{setExpandedAssignment(prev=>prev===id?null:id);setExceptionForm(emptyException);setExceptionError("")};
  const updateExceptionField=(k,v)=>setExceptionForm(prev=>({...prev,[k]:v}));
  const submitException=async(assignmentId,e)=>{
    e.preventDefault();setExceptionError("");
    if(!exceptionForm.start_date||!exceptionForm.end_date){setExceptionError("Inserisci data inizio e fine.");return}
    if(exceptionForm.start_date>exceptionForm.end_date){setExceptionError("La data di inizio deve precedere la data di fine.");return}
    setSavingException(true);
    try{await api.post(`/admin/facilities/${serviceMgr.facility.id}/services/${assignmentId}/exceptions`,exceptionForm);setExceptionForm(emptyException);await reloadAssignments()}
    catch(error){setExceptionError(error.response?.data?.detail||"Impossibile aggiungere l’eccezione")}
    finally{setSavingException(false)}
  };
  const deleteException=async(assignmentId,eid)=>{
    if(!window.confirm("Rimuovere questa eccezione?")) return;
    setExceptionError("");
    try{await api.delete(`/admin/facilities/${serviceMgr.facility.id}/services/${assignmentId}/exceptions/${eid}`);await reloadAssignments()}
    catch(error){setExceptionError(error.response?.data?.detail||"Rimozione non riuscita")}
  };
  const openCreateService=()=>{setServiceForm({...emptyService,open:true});setServiceError("");setServiceMessage("")};
  const openEditService=s=>{setServiceForm({open:true,mode:"edit",id:s.id,name:s.name,category:s.category||"Specialità",active:s.active!==false});setServiceError("");setServiceMessage("")};
  const closeServiceForm=()=>{setServiceForm(prev=>({...prev,open:false}));setServiceError("")};
  const updateServiceField=(k,v)=>setServiceForm(prev=>({...prev,[k]:v}));
  const submitService=async e=>{
    e.preventDefault();setServiceError("");setServiceMessage("");
    if(!serviceForm.name.trim()){setServiceError("Il nome del servizio è obbligatorio.");return}
    setSavingService(true);
    try{
      if(serviceForm.mode==="create"){await api.post("/admin/services",{name:serviceForm.name.trim(),category:serviceForm.category.trim()||"Specialità"});setServiceMessage(`Servizio "${serviceForm.name}" creato in anagrafica.`)}
      else{await api.put(`/admin/services/${serviceForm.id}`,{name:serviceForm.name.trim(),category:serviceForm.category.trim()||"Specialità",active:serviceForm.active});setServiceMessage(`Modifiche salvate per "${serviceForm.name}".`)}
      setServiceForm(emptyService);loadServicesCatalog();
    }catch(error){setServiceError(error.response?.data?.detail||"Operazione non riuscita")}
    finally{setSavingService(false)}
  };
  const toggleServiceActive=async s=>{
    setServiceError("");setServiceMessage("");
    try{await api.put(`/admin/services/${s.id}`,{active:!(s.active!==false)});loadServicesCatalog()}
    catch(error){setServiceError(error.response?.data?.detail||"Operazione non riuscita")}
  };
  const deleteServiceCatalog=async s=>{
    if(!window.confirm(`Eliminare definitivamente il servizio "${s.name}" dall’anagrafica?`)) return;
    setServiceError("");setServiceMessage("");
    try{await api.delete(`/admin/services/${s.id}`);setServiceMessage(`Servizio "${s.name}" eliminato dall’anagrafica.`);loadServicesCatalog()}
    catch(error){setServiceError(error.response?.data?.detail||"Eliminazione non riuscita")}
  };
  const openEditDoc=d=>{setDocForm({open:true,mode:"edit",id:d.id,title:d.title||"",category:d.category||"",version:d.version||"",status:d.status||"active",description:d.description||"",identifier:d.identifier||""});setDocError("");setDocMessage("")};
  const closeDocForm=()=>{setDocForm(prev=>({...prev,open:false}));setDocError("")};
  const updateDocField=(k,v)=>setDocForm(prev=>({...prev,[k]:v}));
  const submitDoc=async e=>{
    e.preventDefault();setDocError("");setDocMessage("");
    if(!docForm.title.trim()){setDocError("Il titolo è obbligatorio.");return}
    setSavingDoc(true);
    try{
      await api.put(`/admin/documents/${docForm.id}`,{title:docForm.title.trim(),category:docForm.category.trim(),version:docForm.version.trim(),status:docForm.status,description:docForm.description,identifier:docForm.identifier.trim()});
      setDocMessage(`Modifiche salvate per "${docForm.title}".`);
      setDocForm(emptyDoc);
      loadDocs();
    }catch(error){setDocError(error.response?.data?.detail||"Operazione non riuscita")}
    finally{setSavingDoc(false)}
  };
  const deleteDoc=async d=>{
    if(!window.confirm(`Eliminare definitivamente "${d.title}"? Verrà rimosso anche dalla Knowledge Base.`)) return;
    setDocError("");setDocMessage("");
    try{await api.delete(`/admin/documents/${d.id}`);setDocMessage(`"${d.title}" eliminato.`);loadDocs()}
    catch(error){setDocError(error.response?.data?.detail||"Eliminazione non riuscita")}
  };
  const cycleDocStatus=async d=>{
    const next=d.status==="active"?"archived":d.status==="archived"?"draft":"active";
    setDocError("");setDocMessage("");
    try{await api.put(`/admin/documents/${d.id}`,{status:next});loadDocs();setDocMessage(`Stato aggiornato: ${next}`)}
    catch(error){setDocError(error.response?.data?.detail||"Operazione non riuscita")}
  };
  const [reindexing,setReindexing]=useState(false);
  const [reindexMessage,setReindexMessage]=useState("");
  const [reindexError,setReindexError]=useState("");
  const reindexDocs=async()=>{
    if(!window.confirm("Ricalcolare chunk ed embeddings di tutti i documenti? L'operazione può richiedere alcuni minuti.")) return;
    setReindexing(true);setReindexMessage("");setReindexError("");
    try{
      const r=await api.post("/admin/documents/reindex",{},{timeout:600000});
      setReindexMessage(`Reindicizzati ${r.data.documents} documenti (${r.data.chunks} chunk) con embeddings semantici.`);
    }catch(error){setReindexError(error.response?.data?.detail||"Reindicizzazione non riuscita")}
    finally{setReindexing(false)}
  };
  const exportData=async kind=>{
    setIoError("");setIoMessage("");
    try{
      const r=await api.get(`/admin/export/${kind}`,{responseType:"blob"});
      const blob=new Blob([r.data],{type:"application/json"});
      const url=window.URL.createObjectURL(blob);
      const a=document.createElement("a");
      const stamp=new Date().toISOString().slice(0,16).replace(/[T:]/g,"-");
      a.href=url; a.download=`${kind==="facilities"?"strutture":"servizi"}-118-${stamp}.json`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setIoMessage(`Export ${kind==="facilities"?"strutture":"servizi"} completato.`);
    }catch(error){setIoError(error.response?.data?.detail||"Export non riuscito")}
  };
  const importData=async(kind,event)=>{
    const file=event.target.files?.[0];
    event.target.value="";
    if(!file) return;
    setIoError("");setIoMessage("");
    if(!window.confirm(`Importare "${file.name}" nell'anagrafica ${kind==="facilities"?"strutture":"servizi"}? Le voci esistenti verranno aggiornate per nome, quelle nuove create.`)) return;
    try{
      const text=await file.text();
      const parsed=JSON.parse(text);
      const items=Array.isArray(parsed)?parsed:(parsed.items||[]);
      if(!Array.isArray(items)||items.length===0){setIoError("Il file non contiene voci da importare.");return}
      const r=await api.post(`/admin/import/${kind}`,{items,replace:false});
      const d=r.data;
      const parts=[];
      if(kind==="services"){parts.push(`Servizi creati: ${d.created}`);parts.push(`aggiornati: ${d.updated}`)}
      else{parts.push(`Strutture create: ${d.facilities_created}`);parts.push(`aggiornate: ${d.facilities_updated}`);parts.push(`associazioni servizio: ${d.services_assigned}`);if(d.auto_created_services>0)parts.push(`servizi creati automaticamente: ${d.auto_created_services}`)}
      setIoMessage(parts.join(" · ")+(d.errors?.length?` — ${d.errors.length} avvisi`:""));
      if(kind==="facilities"){loadFacilities();loadServicesCatalog()}else{loadServicesCatalog()}
    }catch(error){
      if(error instanceof SyntaxError){setIoError("File JSON non valido")}
      else{setIoError(error.response?.data?.detail||error.message||"Import non riuscito")}
    }
  };
  const openTypeMgr=()=>{setTypeMgrOpen(true);setTypeForm(emptyType);setTypeError("");setTypeMessage("");loadFacilityTypes()};
  const closeTypeMgr=()=>{setTypeMgrOpen(false);setTypeForm(emptyType);setTypeError("");setTypeMessage("")};
  const openCreateType=()=>{setTypeForm({...emptyType,open:true});setTypeError("");setTypeMessage("")};
  const openEditType=t=>{setTypeForm({open:true,mode:"edit",id:t.id,name:t.name,active:t.active!==false});setTypeError("");setTypeMessage("")};
  const closeTypeForm=()=>{setTypeForm(prev=>({...prev,open:false}));setTypeError("")};
  const updateTypeField=(k,v)=>setTypeForm(prev=>({...prev,[k]:v}));
  const submitType=async e=>{
    e.preventDefault();setTypeError("");setTypeMessage("");
    if(!typeForm.name.trim()){setTypeError("Il nome è obbligatorio.");return}
    setSavingType(true);
    try{
      if(typeForm.mode==="create"){await api.post("/admin/facility-types",{name:typeForm.name.trim()});setTypeMessage(`Tipologia "${typeForm.name}" creata.`)}
      else{await api.put(`/admin/facility-types/${typeForm.id}`,{name:typeForm.name.trim(),active:typeForm.active});setTypeMessage(`Modifiche salvate.`)}
      setTypeForm(emptyType);
      await Promise.all([loadFacilityTypes(),loadFacilities()]);
    }catch(error){setTypeError(error.response?.data?.detail||"Operazione non riuscita")}
    finally{setSavingType(false)}
  };
  const toggleTypeActive=async t=>{
    setTypeError("");setTypeMessage("");
    try{await api.put(`/admin/facility-types/${t.id}`,{active:!(t.active!==false)});await loadFacilityTypes()}
    catch(error){setTypeError(error.response?.data?.detail||"Operazione non riuscita")}
  };
  const deleteType=async t=>{
    if(!window.confirm(`Eliminare la tipologia "${t.name}"?`)) return;
    setTypeError("");setTypeMessage("");
    try{await api.delete(`/admin/facility-types/${t.id}`);setTypeMessage(`Tipologia "${t.name}" eliminata.`);await loadFacilityTypes()}
    catch(error){setTypeError(error.response?.data?.detail||"Eliminazione non riuscita")}
  };
  const toggleSort=col=>setFacilitySort(prev=>prev.column===col?{column:col,asc:!prev.asc}:{column:col,asc:true});
  const uniqueProvinces=Array.from(new Set(facilities.map(f=>f.province).filter(Boolean))).sort();
  const filteredFacilities=facilities.filter(f=>{
    if(facilityFilter.q&&!(`${f.name} ${f.address||""} ${f.city||""}`).toLowerCase().includes(facilityFilter.q.toLowerCase())) return false;
    if(facilityFilter.type&&f.type!==facilityFilter.type) return false;
    if(facilityFilter.province&&f.province!==facilityFilter.province) return false;
    return true;
  }).sort((a,b)=>{
    const col=facilitySort.column;
    const av=(a[col]||"").toString().toLowerCase();
    const bv=(b[col]||"").toString().toLowerCase();
    if(av<bv) return facilitySort.asc?-1:1;
    if(av>bv) return facilitySort.asc?1:-1;
    return 0;
  });
  const labels={overview:["AMMINISTRAZIONE / PANORAMICA","Console amministrativa","Gestisci dati, utenti e documentazione della Centrale."],facilities:["AMMINISTRAZIONE / ANAGRAFICHE","Strutture sanitarie","Anagrafica delle strutture con relative associazioni di servizi."],services:["AMMINISTRAZIONE / ANAGRAFICA","Servizi e specialità","Tipologie di servizio disponibili per le strutture."],algorithms:["AMMINISTRAZIONE","Gestione Algoritmi","Gestione degli algoritmi"],documents:["AMMINISTRAZIONE / DOCUMENTI","Documenti e versioni","Knowledge Base, stato e versioni delle procedure."],users:["AMMINISTRAZIONE / ACCESSI","Utenti e autorizzazioni","Account creati e gestiti dall’amministratore."],roles:[
  "AMMINISTRAZIONE / ACCESSI",
  "Ruoli e permessi",
  "Configura i ruoli e le autorizzazioni degli utenti."],audit:["AMMINISTRAZIONE / TRACCIABILITÀ","Audit log","Storico delle principali operazioni amministrative."]};
  const [k,t,s]=labels[section]||labels.overview;

// Nodi utilizzati esclusivamente per l'anteprima.
// Durante la modifica sostituiamo temporaneamente il nodo originale
// con editingNode, senza modificare flowEditor.nodes.
const previewNodes = flowEditor.nodes.map(node => {
  if (!editingNode || node.id !== editingNode.id) {
    return node;
  }

  return {
    ...editingNode,
    x: Number(editingNode.x),
    y: Number(editingNode.y),
    width: Number(editingNode.width),
    height: Number(editingNode.height)
  };
});

// Edge utilizzati esclusivamente per l'anteprima.
// Durante la modifica sostituiamo temporaneamente l'edge originale
// con editingEdge, senza modificare flowEditor.edges.
const previewEdges = flowEditor.edges.map((edge, index) => {
  if (!editingEdge || index !== editingEdge._index) {
    return edge;
  }

  const {
    _index,
    ...previewEdge
  } = editingEdge;

  return {
    ...previewEdge,
    points: (previewEdge.points || []).map(point => ({
      ...point,
      x: Number(point.x),
      y: Number(point.y)
    }))
  };
});

  return <>
    <Header showStatus={!["overview", "users", "roles", "audit"].includes(section)} kicker={k} title={t} subtitle={s}/>
    {section==="overview"&&
      <div className="admin-overview">
        <div className="admin-stats">
          {[
            ["Strutture",data?.stats.facilities,"facilities"],
            ["Servizi",data?.stats.services,"services"],
            ["Documenti attivi",data?.stats.documents,"documents"],
            ["Utenti attivi",data?.stats.users,"users"]
          ].map(([l,v,c])=>
            <div
              className="admin-stat"
              data-testid={`admin-stat-${c}`}
              key={c}
            >
              <span>{l}</span>
              <b>{v??"—"}</b>
              <small>DATI DEMO</small>
            </div>
          )}
        </div>

        <div className="admin-quick">
          <div>
            <span className="eyebrow">AZIONI RAPIDE</span>
            <h2>Gestione del sistema</h2>
          </div>

          <div className="quick-links">
            {can("admin.facilities.read")&&
              <NavLink
                data-testid="admin-overview-facilities-link"
                to="/admin/strutture"
              >
                <Building2/>Gestisci strutture<ChevronRight/>
              </NavLink>
            }

            {can("admin.services.read")&&
              <NavLink
                data-testid="admin-overview-services-link"
                to="/admin/servizi"
              >
                <Layers/>Anagrafica servizi<ChevronRight/>
              </NavLink>
            }

            {can("admin.documents.read")&&
              <NavLink
                data-testid="admin-overview-documents-link"
                to="/admin/documenti"
              >
                <FileText/>Gestisci documenti<ChevronRight/>
              </NavLink>
            }

            {can("admin.users.read")&&
              <NavLink
                data-testid="admin-overview-users-link"
                to="/admin/utenti"
              >
                <Users/>Gestisci utenti<ChevronRight/>
              </NavLink>
            }

            {can("admin.roles.read")&&
              <NavLink
                data-testid="admin-overview-roles-link"
                to="/admin/ruoli"
              >
                <ShieldCheck/>Gestisci ruoli<ChevronRight/>
              </NavLink>
            }

            {can("admin.algorithms.read")&&
              <NavLink
                data-testid="admin-overview-algorithms-link"
                to="/admin/algoritmi"
              >
                <GitBranch/>Gestisci algoritmi<ChevronRight/>
              </NavLink>
            }

            {can("admin.android_updates.read")&&
              <NavLink data-testid="admin-overview-android-updates-link" to="/admin/android-updates">
                <Upload/>Aggiornamenti Android<ChevronRight/>
              </NavLink>
            }

            {isRealAdmin&&
              <NavLink
                data-testid="admin-overview-system-releases-link"
                to="/admin/rilasci"
              >
                <History/>Gestione rilasci<ChevronRight/>
              </NavLink>
            }

            {can("admin.audit.read")&&
              <NavLink
                data-testid="admin-overview-audit-link"
                to="/admin/audit"
              >
                <ScrollText/>Audit log<ChevronRight/>
              </NavLink>
            }
          </div>
        </div>
      </div>
    }
    {section==="facilities"&&<>
      <div className="admin-toolbar">
  {can("admin.facilities.write")&&<>
    <button
      data-testid="open-create-facility-button"
      type="button"
      className="primary-btn"
      onClick={()=>facilityForm.open?closeFacilityForm():openCreateFacility()}
    >
      <Plus size={16}/>
      {facilityForm.open&&facilityForm.mode==="create"?"Chiudi":"Nuova struttura"}
    </button>

    <button
      data-testid="open-type-manager-button"
      type="button"
      className="row-btn"
      onClick={openTypeMgr}
    >
      <Layers size={13}/> Gestisci tipologie
    </button>

    <FacilitiesPdfExport
      facilities={facilities}
      facilityTypes={facilityTypes}
      api={api}
    />

    <button
      data-testid="export-facilities-button"
      type="button"
      className="row-btn"
      onClick={()=>exportData("facilities")}
    >
      <Download size={13}/> Esporta JSON
    </button>

    <label
      className="row-btn"
      data-testid="import-facilities-label"
    >
      <Upload size={13}/> Importa JSON
      <input
        data-testid="import-facilities-input"
        type="file"
        accept="application/json,.json"
        hidden
        onChange={e=>importData("facilities",e)}
      />
    </label>
  </>}

  <span>{filteredFacilities.length} di {facilities.length} strutture</span>
</div>

      <div className="filter-bar" data-testid="facility-filter-bar">
        <label><Search size={13}/><input data-testid="facility-filter-q" placeholder="Cerca per nome, indirizzo, comune" value={facilityFilter.q} onChange={e=>setFacilityFilter(prev=>({...prev,q:e.target.value}))}/></label>
        <select data-testid="facility-filter-type" value={facilityFilter.type} onChange={e=>setFacilityFilter(prev=>({...prev,type:e.target.value}))}><option value="">Tutte le tipologie</option>{facilityTypes.filter(t=>t.active!==false).map(t=><option key={t.id} value={t.name}>{t.name}</option>)}</select>
        <select data-testid="facility-filter-province" value={facilityFilter.province} onChange={e=>setFacilityFilter(prev=>({...prev,province:e.target.value}))}><option value="">Tutte le province</option>{uniqueProvinces.map(p=><option key={p} value={p}>{p}</option>)}</select>
        {(facilityFilter.q||facilityFilter.type||facilityFilter.province)&&<button data-testid="facility-filter-reset" type="button" className="row-btn" onClick={()=>setFacilityFilter({q:"",type:"",province:""})}><X size={12}/> Azzera</button>}
      </div>
      {ioMessage&&<div className="success" data-testid="io-success">{ioMessage}</div>}
      {ioError&&<div className="error" data-testid="io-error">{ioError}</div>}
      {facilityForm.open&&<form className="user-create-form" data-testid="facility-form" onSubmit={submitFacility}>
        <div className="user-create-heading"><span className="eyebrow">{facilityForm.mode==="edit"?"MODIFICA STRUTTURA":"NUOVA STRUTTURA"}</span><b>{facilityForm.mode==="edit"?facilityForm.name||"Struttura":"Aggiungi struttura"}</b><small>Compila i campi anagrafici. I dati sono utilizzati dalla ricerca operativa.</small></div>
        <div className="user-create-grid">
          <label>Nome<input data-testid="facility-name-input" required value={facilityForm.name} onChange={e=>updateFacilityField("name",e.target.value)} placeholder="Es. Ospedale Sant'Anna"/></label>
          <label>Tipo<select data-testid="facility-type-select" value={facilityForm.type} onChange={e=>updateFacilityField("type",e.target.value)}>{facilityTypes.filter(t=>t.active!==false||t.name===facilityForm.type).map(t=><option key={t.id} value={t.name}>{t.name}</option>)}{facilityForm.type&&!facilityTypes.some(t=>t.name===facilityForm.type)&&<option value={facilityForm.type}>{facilityForm.type}</option>}</select></label>
          <label>Indirizzo<input data-testid="facility-address-input" value={facilityForm.address} onChange={e=>updateFacilityField("address",e.target.value)} placeholder="Via / Piazza"/></label>
          <label>Comune<input data-testid="facility-city-input" value={facilityForm.city} onChange={e=>updateFacilityField("city",e.target.value)}/></label>
          <label>Provincia<input data-testid="facility-province-input" value={facilityForm.province} onChange={e=>updateFacilityField("province",e.target.value)} maxLength="2" placeholder="BO"/></label>
          <label>Telefono<input data-testid="facility-phone-input" value={facilityForm.phone} onChange={e=>updateFacilityField("phone",e.target.value)} placeholder="051 000 000"/></label>
          <label>Latitudine (facoltativa)<input data-testid="facility-latitude-input" type="number" step="any" min="-90" max="90" value={facilityForm.latitude} onChange={e=>updateFacilityField("latitude",e.target.value)} placeholder="Es. 44.493900"/></label>
          <label>Longitudine (facoltativa)<input data-testid="facility-longitude-input" type="number" step="any" min="-180" max="180" value={facilityForm.longitude} onChange={e=>updateFacilityField("longitude",e.target.value)} placeholder="Es. 11.342600"/></label>
          <label className="span-2">Note<textarea data-testid="facility-notes-input" rows="2" value={facilityForm.notes} onChange={e=>updateFacilityField("notes",e.target.value)} placeholder="Note operative"/></label>
          <label className="inline-check"><input data-testid="facility-active-checkbox" type="checkbox" checked={facilityForm.active} onChange={e=>updateFacilityField("active",e.target.checked)}/> Struttura attiva</label>
        </div>
        {facilityError&&<div className="error" data-testid="facility-error">{facilityError}</div>}
        <div className="user-create-actions">
          <button type="button" data-testid="cancel-facility-button" onClick={closeFacilityForm}>Annulla</button>
          <button data-testid="facility-submit-button" className="primary-btn" disabled={savingFacility} type="submit">{savingFacility?"Salvataggio…":facilityForm.mode==="edit"?"Salva modifiche":"Crea struttura"}</button>
        </div>
      </form>}
      {facilityMessage&&<div className="success" data-testid="facility-success">{facilityMessage}</div>}
      <div className="table-wrap"><table><thead><tr>{[["name","STRUTTURA"],["type","TIPO"],["city","LOCALITÀ"],["province","PROV."]].map(([col,label])=><th key={col} data-testid={`sort-${col}-header`} className="sortable" onClick={()=>toggleSort(col)}>{label} {facilitySort.column===col?<span className="sort-indicator">{facilitySort.asc?"▲":"▼"}</span>:null}</th>)}<th>STATO</th><th>AZIONI</th></tr></thead><tbody>{filteredFacilities.length===0&&<tr><td colSpan="6" className="empty-row">Nessuna struttura corrisponde ai filtri applicati.</td></tr>}{filteredFacilities.map(f=><tr key={f.id} data-testid={`admin-facility-${f.id}`}><td><b>{f.name}</b><small>{f.address}</small></td><td>{f.type}</td><td>{f.city}</td><td>{f.province}</td><td><span className={f.active?"table-status":"table-status off"}><i/>{f.active?"Attiva":"Disattiva"}</span></td><td className="row-actions">
  {can("admin.facilities.write")&&<>
    <button
      data-testid={`services-facility-${f.id}-button`}
      className="row-btn"
      type="button"
      onClick={()=>openServiceMgr(f)}
    >
      <ClipboardList size={12}/> Servizi
    </button>

    <button
      data-testid={`edit-facility-${f.id}-button`}
      className="row-btn"
      type="button"
      onClick={()=>openEditFacility(f)}
    >
      <Edit2 size={12}/> Modifica
    </button>

    <button
      data-testid={`delete-facility-${f.id}-button`}
      className="row-btn danger"
      type="button"
      onClick={()=>deleteFacility(f)}
    >
      <Trash2 size={12}/> Elimina
    </button>
  </>}
</td>
</tr>)}</tbody></table></div>
      {typeMgrOpen&&<div className="service-mgr-overlay" data-testid="type-manager" onClick={e=>{if(e.target===e.currentTarget)closeTypeMgr()}}>
        <div className="service-mgr-panel">
          <div className="service-mgr-head"><span className="eyebrow">TIPOLOGIE STRUTTURA</span><b>Anagrafica tipologie</b><button type="button" data-testid="close-type-manager-button" className="icon-btn" onClick={closeTypeMgr}><X size={22}/></button></div>
          <div className="service-mgr-toolbar"><button data-testid="add-type-button" type="button" className="primary-btn" onClick={()=>typeForm.open&&typeForm.mode==="create"?closeTypeForm():openCreateType()}><Plus size={16}/> {typeForm.open&&typeForm.mode==="create"?"Chiudi":"Nuova tipologia"}</button><span>{facilityTypes.length} tipologie in anagrafica</span></div>
          {typeForm.open&&<form className="user-create-form" data-testid="type-form" onSubmit={submitType}>
            <div className="user-create-heading"><span className="eyebrow">{typeForm.mode==="edit"?"MODIFICA TIPOLOGIA":"NUOVA TIPOLOGIA"}</span><b>{typeForm.mode==="edit"?typeForm.name:"Aggiungi tipologia"}</b><small>Le tipologie disattivate non compaiono più nel form delle nuove strutture.</small></div>
            <div className="user-create-grid">
              <label>Nome<input data-testid="type-name-input" required minLength="2" value={typeForm.name} onChange={e=>updateTypeField("name",e.target.value)} placeholder="Es. Hospice"/></label>
              {typeForm.mode==="edit"&&<label className="inline-check"><input data-testid="type-active-checkbox" type="checkbox" checked={typeForm.active} onChange={e=>updateTypeField("active",e.target.checked)}/> Tipologia attiva</label>}
            </div>
            {typeError&&<div className="error error-in-form">{typeError}</div>}
            <div className="user-create-actions"><button type="button" data-testid="cancel-type-button" onClick={closeTypeForm}>Annulla</button><button data-testid="type-submit-button" className="primary-btn" disabled={savingType} type="submit">{savingType?"Salvataggio…":typeForm.mode==="edit"?"Salva modifiche":"Crea tipologia"}</button></div>
          </form>}
          {typeMessage&&<div className="success" data-testid="type-success">{typeMessage}</div>}
          {typeError&&!typeForm.open&&<div className="error" data-testid="type-error">{typeError}</div>}
          <div className="table-wrap"><table><thead><tr><th>TIPOLOGIA</th><th>STATO</th><th>AZIONI</th></tr></thead><tbody>{facilityTypes.length===0&&<tr><td colSpan="3" className="empty-row">Nessuna tipologia in anagrafica.</td></tr>}{facilityTypes.map(t=><tr key={t.id} data-testid={`admin-type-${t.id}`}><td><b>{t.name}</b></td><td><span className={t.active!==false?"table-status":"table-status off"}><i/>{t.active!==false?"Attiva":"Disattivata"}</span></td><td className="row-actions"><button data-testid={`edit-type-${t.id}-button`} className="row-btn" type="button" onClick={()=>openEditType(t)}><Edit2 size={12}/> Modifica</button><button data-testid={`toggle-type-${t.id}-button`} className="row-btn" type="button" onClick={()=>toggleTypeActive(t)}>{t.active!==false?"Disattiva":"Riattiva"}</button><button data-testid={`delete-type-${t.id}-button`} className="row-btn danger" type="button" onClick={()=>deleteType(t)}><Trash2 size={12}/> Elimina</button></td></tr>)}</tbody></table></div>
        </div>
      </div>}
      {serviceMgr.open&&<div className="service-mgr-overlay" data-testid="service-manager" onClick={e=>{if(e.target===e.currentTarget)closeServiceMgr()}}>
        <div className="service-mgr-panel">
          <div className="service-mgr-head"><span className="eyebrow">SERVIZI ASSOCIATI</span><b>{serviceMgr.facility.name}</b><button type="button" data-testid="close-service-manager-button" className="icon-btn" onClick={closeServiceMgr}><X size={22}/></button></div>
          <div className="service-mgr-toolbar"><button data-testid="add-assignment-button" type="button" className="primary-btn" onClick={()=>assignmentForm.open&&assignmentForm.mode==="create"?closeAssignmentForm():openAddAssignment()}><Plus size={16}/> {assignmentForm.open&&assignmentForm.mode==="create"?"Chiudi":"Aggiungi servizio"}</button><span>{assignments.length} servizi associati</span></div>
          {assignmentForm.open&&<form className="user-create-form" data-testid="assignment-form" onSubmit={submitAssignment}>
            <div className="user-create-heading"><span className="eyebrow">{assignmentForm.mode==="edit"?"MODIFICA ASSOCIAZIONE":"NUOVA ASSOCIAZIONE"}</span><b>{assignmentForm.mode==="edit"?(assignments.find(a=>a.id===assignmentForm.id)?.service_name||"Servizio"):"Aggiungi servizio alla struttura"}</b><small>Definisci giorni e orari. Un servizio sospeso non compare nelle ricerche degli operatori.</small></div>
            <div className="user-create-grid">
              <label className="span-2">Servizio<select data-testid="assignment-service-select" required value={assignmentForm.service_id} onChange={e=>updateAssignField("service_id",e.target.value)} disabled={assignmentForm.mode==="edit"}><option value="">Seleziona un servizio dall’anagrafica</option>{allServices.filter(s=>assignmentForm.mode==="edit"||!assignments.some(a=>a.service_id===s.id)).map(s=><option key={s.id} value={s.id}>{s.name}</option>)}</select></label>
              <label className="inline-check span-2"><input data-testid="assignment-h24-checkbox" type="checkbox" checked={assignmentForm.h24} onChange={e=>updateAssignField("h24",e.target.checked)}/> Servizio disponibile H24 tutti i giorni</label>
{!assignmentForm.h24&&
  <div className="span-2">
    {assignmentForm.schedule.map((slot,index)=>
      <div className="time-slot-card" key={index}>
        <div className="time-slot-head">
          <b>Fascia {index+1}</b>

          {assignmentForm.schedule.length>1&&
            <button
              type="button"
              className="row-btn danger"
              data-testid={`remove-time-slot-${index}-button`}
              onClick={()=>removeTimeSlot(index)}
            >
              <Trash2 size={12}/> Elimina fascia
            </button>
          }
        </div>

        <div className="time-slot-grid">
          <label>
            Orario inizio
            <input
              data-testid={`assignment-start-${index}-input`}
              type="time"
              required
              value={slot.start}
              onChange={e=>updateTimeSlot(index,"start",e.target.value)}
            />
          </label>

          <label>
            Orario fine
            <input
              data-testid={`assignment-end-${index}-input`}
              type="time"
              required
              value={slot.end}
              onChange={e=>updateTimeSlot(index,"end",e.target.value)}
            />
          </label>

          <label className="span-2">
            Giorni della settimana

            <div className="days-picker">
              {DAY_LABELS.map((label,day)=>
                <button
                  type="button"
                  key={day}
                  data-testid={`assignment-slot-${index}-day-${day}-button`}
                  className={slot.days.includes(day)?"day-btn on":"day-btn"}
                  onClick={()=>toggleSlotDay(index,day)}
                >
                  {label}
                </button>
              )}
            </div>
          </label>
        </div>
      </div>
    )}

    <button
      type="button"
      className="row-btn"
      data-testid="add-time-slot-button"
      onClick={addTimeSlot}
    >
      <Plus size={14}/> Aggiungi fascia
    </button>
  </div>
}
              <label className="span-2">Note operative<textarea data-testid="assignment-notes-input" rows="2" value={assignmentForm.notes} onChange={e=>updateAssignField("notes",e.target.value)} placeholder="Es. contatto interno, restrizioni, referente"/></label>
              <label className="inline-check span-2"><input data-testid="assignment-active-checkbox" type="checkbox" checked={assignmentForm.active} onChange={e=>updateAssignField("active",e.target.checked)}/> Servizio attivo (visibile agli operatori)</label>
            </div>
            {assignmentError&&<div className="error" data-testid="assignment-error">{assignmentError}</div>}
            <div className="user-create-actions"><button type="button" data-testid="cancel-assignment-button" onClick={closeAssignmentForm}>Annulla</button><button data-testid="assignment-submit-button" className="primary-btn" disabled={savingAssignment} type="submit">{savingAssignment?"Salvataggio…":assignmentForm.mode==="edit"?"Salva modifiche":"Associa servizio"}</button></div>
          </form>}
          {assignmentMessage&&<div className="success" data-testid="assignment-success">{assignmentMessage}</div>}
          <div className="table-wrap"><table><thead><tr><th>SERVIZIO</th><th>DISPONIBILITÀ</th><th>NOTE</th><th>STATO</th><th>AZIONI</th></tr></thead><tbody>{assignments.length===0&&<tr><td colSpan="5" className="empty-row">Nessun servizio ancora associato a questa struttura.</td></tr>}{assignments.map(a=>{const exs=a.exceptions||[];const isExpanded=expandedAssignment===a.id;return <React.Fragment key={a.id}><tr data-testid={`assignment-${a.id}`}><td><b>{a.service_name}</b><small>{a.service_category}</small></td><td>
  {a.h24
    ? "H24 · tutti i giorni"
    : (
        Array.isArray(a.schedule) && a.schedule.length
          ? <div className="availability-slots">
              {a.schedule.map((slot,index)=>
                <div className="availability-slot" key={index}>
                  <b>{slot.start}–{slot.end}</b>
                  <small>
                    {(slot.days||[]).map(d=>DAY_LABELS[d]).join(", ")||"—"}
                  </small>
                </div>
              )}
            </div>
          : `${(a.days||[]).map(d=>DAY_LABELS[d]).join(", ")||"—"} · ${a.start}–${a.end}`
      )
  }
</td><td>{a.notes||"—"}</td><td><span className={a.active!==false?"table-status":"table-status off"}><i/>{a.active!==false?"Attivo":"Sospeso"}</span></td><td className="row-actions"><button data-testid={`exceptions-assignment-${a.id}-button`} className={exs.length?"row-btn accent":"row-btn"} type="button" onClick={()=>toggleExpandAssignment(a.id)}><CalendarOff size={12}/> Eccezioni {exs.length>0&&<span className="pill">{exs.length}</span>}</button><button data-testid={`edit-assignment-${a.id}-button`} className="row-btn" type="button" onClick={()=>openEditAssignment(a)}><Edit2 size={12}/> Modifica</button><button data-testid={`toggle-assignment-${a.id}-button`} className="row-btn" type="button" onClick={()=>toggleAssignmentActive(a)}>{a.active!==false?"Sospendi":"Riattiva"}</button><button data-testid={`delete-assignment-${a.id}-button`} className="row-btn danger" type="button" onClick={()=>deleteAssignment(a)}><Trash2 size={12}/> Rimuovi</button></td></tr>{isExpanded&&<tr className="exception-row"><td colSpan="5"><div className="exception-panel" data-testid={`exception-panel-${a.id}`}><div className="exception-head"><b>Eccezioni orarie · {a.service_name}</b><small>Nei periodi elencati il servizio è escluso dalla ricerca degli operatori.</small></div><form className="exception-form" data-testid={`exception-form-${a.id}`} onSubmit={ev=>submitException(a.id,ev)}><label>Dal<input type="date" required data-testid={`exception-start-input-${a.id}`} value={exceptionForm.start_date} onChange={e=>updateExceptionField("start_date",e.target.value)}/></label><label>Al<input type="date" required data-testid={`exception-end-input-${a.id}`} value={exceptionForm.end_date} onChange={e=>updateExceptionField("end_date",e.target.value)}/></label><label className="grow">Motivo<input type="text" data-testid={`exception-reason-input-${a.id}`} value={exceptionForm.reason} onChange={e=>updateExceptionField("reason",e.target.value)} placeholder="Es. manutenzione TAC"/></label><button className="primary-btn" data-testid={`exception-submit-${a.id}-button`} type="submit" disabled={savingException}><Plus size={14}/> {savingException?"Salvo…":"Aggiungi"}</button></form>{exceptionError&&<div className="error" data-testid={`exception-error-${a.id}`}>{exceptionError}</div>}<ul className="exception-list">{exs.length===0&&<li className="empty">Nessuna eccezione registrata.</li>}{exs.map(x=><li key={x.id} data-testid={`exception-${x.id}`}><div><b>{new Date(x.start_date).toLocaleDateString("it-IT")} — {new Date(x.end_date).toLocaleDateString("it-IT")}</b><small>{x.reason||"Nessun motivo indicato"}</small></div><button className="row-btn danger" data-testid={`delete-exception-${x.id}-button`} type="button" onClick={()=>deleteException(a.id,x.id)}><Trash2 size={12}/> Elimina</button></li>)}</ul></div></td></tr>}</React.Fragment>})}</tbody></table></div>
        </div>
      </div>}
    </>}
    {section==="services"&&<>
      <div className="admin-toolbar">
  {can("admin.services.write")&&
    <button
      data-testid="open-create-service-button"
      type="button"
      className="primary-btn"
      onClick={()=>serviceForm.open?closeServiceForm():openCreateService()}
    >
      <Plus size={16}/>
      {serviceForm.open&&serviceForm.mode==="create"?"Chiudi":"Nuovo servizio"}
    </button>
  }

  <button
    data-testid="export-services-button"
    type="button"
    className="row-btn"
    onClick={()=>exportData("services")}
  >
    <Download size={13}/> Esporta JSON
  </button>

  {can("admin.services.write")&&
    <label className="row-btn" data-testid="import-services-label">
      <Upload size={13}/> Importa JSON
      <input
        data-testid="import-services-input"
        type="file"
        accept="application/json,.json"
        hidden
        onChange={e=>importData("services",e)}
      />
    </label>
  }

  <span>{servicesCatalog.length} servizi</span>
</div>
      {ioMessage&&<div className="success" data-testid="io-success-services">{ioMessage}</div>}
      {ioError&&<div className="error" data-testid="io-error-services">{ioError}</div>}
      {can("admin.services.write")&&serviceForm.open&&<form className="user-create-form" data-testid="service-form" onSubmit={submitService}>
        <div className="user-create-heading"><span className="eyebrow">{serviceForm.mode==="edit"?"MODIFICA SERVIZIO":"NUOVO SERVIZIO"}</span><b>{serviceForm.mode==="edit"?serviceForm.name||"Servizio":"Aggiungi tipo di servizio"}</b><small>I servizi qui censiti possono essere associati alle strutture nella sezione Strutture.</small></div>
        <div className="user-create-grid">
          <label>Nome<input data-testid="service-name-input" required minLength="2" value={serviceForm.name} onChange={e=>updateServiceField("name",e.target.value)} placeholder="Es. Neurochirurgia"/></label>
          <label>Categoria<input data-testid="service-category-input" value={serviceForm.category} onChange={e=>updateServiceField("category",e.target.value)} placeholder="Es. Specialità"/></label>
          {serviceForm.mode==="edit"&&<label className="inline-check span-2"><input data-testid="service-active-checkbox" type="checkbox" checked={serviceForm.active} onChange={e=>updateServiceField("active",e.target.checked)}/> Servizio attivo (utilizzabile nelle nuove associazioni)</label>}
        </div>
        {serviceError&&<div className="error" data-testid="service-error">{serviceError}</div>}
        <div className="user-create-actions">
          <button type="button" data-testid="cancel-service-button" onClick={closeServiceForm}>Annulla</button>
          <button data-testid="service-submit-button" className="primary-btn" disabled={savingService} type="submit">{savingService?"Salvataggio…":serviceForm.mode==="edit"?"Salva modifiche":"Crea servizio"}</button>
        </div>
      </form>}
      {serviceMessage&&<div className="success" data-testid="service-success">{serviceMessage}</div>}
      {serviceError&&!serviceForm.open&&<div className="error" data-testid="service-error-inline">{serviceError}</div>}
      <div className="table-wrap"><table><thead><tr><th>SERVIZIO</th><th>CATEGORIA</th><th>STATO</th><th>AZIONI</th></tr></thead><tbody>{servicesCatalog.length===0&&<tr><td colSpan="4" className="empty-row">Nessun servizio in anagrafica.</td></tr>}{servicesCatalog.map(s=><tr key={s.id} data-testid={`admin-service-${s.id}`}><td><b>{s.name}</b><small>ID: {s.id}</small></td><td>{s.category||"—"}</td><td><span className={s.active!==false?"table-status":"table-status off"}><i/>{s.active!==false?"Attivo":"Disattivato"}</span></td><td className="row-actions">
  {can("admin.services.write")&&<>
    <button
      data-testid={`edit-service-${s.id}-button`}
      className="row-btn"
      type="button"
      onClick={()=>openEditService(s)}
    >
      <Edit2 size={12}/> Modifica
    </button>

    <button
      data-testid={`toggle-service-${s.id}-button`}
      className="row-btn"
      type="button"
      onClick={()=>toggleServiceActive(s)}
    >
      {s.active!==false?"Disattiva":"Riattiva"}
    </button>

    <button
      data-testid={`delete-service-${s.id}-button`}
      className="row-btn danger"
      type="button"
      onClick={()=>deleteServiceCatalog(s)}
    >
      <Trash2 size={12}/> Elimina
    </button>
  </>}
</td>
</tr>)}</tbody></table></div>
    </>}
    {section === "algorithms" && ( //Gestione algoritmi
  <>
    <section className="panel">

      <div className="panel-head">
{can("admin.algorithms.write") && (
  <button
    type="button"
    className="primary-btn"
    onClick={newAlgorithm}
  >
    + Nuovo algoritmo
  </button>
)}
      </div>


      {algorithms.length === 0 ? (
        <div className="empty-row">
          Nessun algoritmo presente.
        </div>
      ) : (

        <div className="algorithm-admin-list">

          {algorithms.map(algorithm => (

            <div
              key={algorithm.id}
              className="algorithm-admin-row"
            >

              <div className="algorithm-admin-number">
                {algorithm.number}
              </div>


              <div className="algorithm-admin-info">

                <span className="eyebrow">
                  ALGORITMO N° {algorithm.number}
                </span>

                <h3>{algorithm.title}</h3>

                <div className="algorithm-admin-meta">

                  {algorithm.document && (
                    <span>{algorithm.document}</span>
                  )}

                  {algorithm.attachment && (
                    <span>{algorithm.attachment}</span>
                  )}

                  {algorithm.revision && (
                    <span>
                      Rev. {algorithm.revision}
                    </span>
                  )}

                </div>

              </div>


              <div className="algorithm-admin-status">

                <span
                  className={
                    `algorithm-status status-${algorithm.status}`
                  }
                >
                  {algorithm.status === "active"
                    ? "Attivo"
                    : algorithm.status === "archived"
                      ? "Archiviato"
                      : "Bozza"}
                </span>

              </div>


              {can("admin.algorithms.write") && (
  <div className="algorithm-admin-actions">

    <button
      type="button"
      className="row-btn"
      onClick={() => openFlowEditor(algorithm)}
      disabled={flowLoading}
    >
      Flowchart
    </button>

    <button
      type="button"
      className="row-btn"
      onClick={() => editAlgorithm(algorithm)}
    >
      Modifica
    </button>

    <button
      type="button"
      className="row-btn algorithm-delete-btn"
      onClick={() => deleteAlgorithm(algorithm)}
    >
      Elimina
    </button>

  </div>
)}

            </div>

          ))}

        </div>

      )}

    </section>


    {can("admin.algorithms.write") && showAlgorithmForm && (

      <section className="panel algorithm-form-panel">

        <div className="panel-head">

          <div>
            <span className="eyebrow">
              {editingAlgorithm
                ? "MODIFICA"
                : "NUOVO ALGORITMO"}
            </span>
            <h2>
              {editingAlgorithm
                ? `Algoritmo n° ${editingAlgorithm.number}`
                : "Nuovo algoritmo"}
            </h2>
          </div>

          <button
            type="button"
            className="row-btn"
            onClick={closeAlgorithmForm}
          >
            Chiudi
          </button>

        </div>
        <form
          className="algorithm-admin-form"
          onSubmit={saveAlgorithm}
        >

          <div className="algorithm-form-grid">


            <label>
              <span>Numero algoritmo *</span>

              <input
                type="number"
                min="1"
                required
                value={algorithmForm.number}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    number: e.target.value
                  })
                }
              />
            </label>
            <label className="algorithm-title-field">
              <span>Titolo *</span>

              <input
                type="text"
                required
                value={algorithmForm.title}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    title: e.target.value
                  })
                }
              />
            </label>


            <label>
              <span>Documento</span>

              <input
                type="text"
                placeholder="Es. IO N"
                value={algorithmForm.document}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    document: e.target.value
                  })
                }
              />
            </label>


            <label>
              <span>Allegato</span>

              <input
                type="text"
                placeholder="Es. Allegato 7"
                value={algorithmForm.attachment}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    attachment: e.target.value
                  })
                }
              />
            </label>


            <label>
              <span>Revisione</span>

              <input
                type="text"
                placeholder="Es. 0"
                value={algorithmForm.revision}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    revision: e.target.value
                  })
                }
              />
            </label>


            <label>
              <span>Stato</span>

              <select
                value={algorithmForm.status}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    status: e.target.value
                  })
                }
              >
                <option value="draft">
                  Bozza
                </option>

                <option value="active">
                  Attivo
                </option>

                <option value="archived">
                  Archiviato
                </option>
              </select>
            </label>


            <label>
              <span>Data emissione</span>

              <input
                type="date"
                value={algorithmForm.issue_date}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    issue_date: e.target.value
                  })
                }
              />
            </label>


            <label>
              <span>Data applicazione</span>

              <input
                type="date"
                value={algorithmForm.application_date}
                onChange={e =>
                  setAlgorithmForm({
                    ...algorithmForm,
                    application_date: e.target.value
                  })
                }
              />
            </label>

          </div>


          {algorithmError && (
            <div className="algorithm-form-error">
              {algorithmError}
            </div>
          )}


          <div className="algorithm-form-actions">

            <button
              type="button"
              className="row-btn"
              onClick={closeAlgorithmForm}
              disabled={algorithmSaving}
            >
              Annulla
            </button>

            <button
              type="submit"
              className="primary-btn"
              disabled={algorithmSaving}
            >
              {algorithmSaving
                ? "Salvataggio..."
                : editingAlgorithm
                  ? "Salva modifiche"
                  : "Crea algoritmo"}
            </button>
          </div>

                </form>

      </section>

    )}

    {can("admin.algorithms.write") && flowEditor.open && (
      <section className="panel algorithm-form-panel">

        <div className="panel-head">
          <div>
            <span className="eyebrow">
              FLOWCHART
            </span>

            <h2>
              Algoritmo n° {flowEditor.algorithm?.number}
            </h2>

            <p>
              {flowEditor.algorithm?.title}
            </p>
          </div>

          <button
    type="button"
    className="primary-btn"
    onClick={saveFlowchart}
    disabled={flowSaving}
  >
    {flowSaving
      ? "Salvataggio..."
      : "Salva flowchart"}
  </button>

{flowSaveMessage && (
  <span
    className={
      flowSaveMessageType === "success"
        ? "flow-save-message success"
        : "flow-save-message error"
    }
  >
    {flowSaveMessage}
  </span>
)}

  <button
    type="button"
    className="row-btn"
    onClick={closeFlowEditor}
    disabled={flowSaving}
  >
    Chiudi
  </button>
        </div>

        <div className="flow-admin-summary"> {/* Riepilogo */}
          <div>
            <strong>{flowEditor.nodes.length}</strong>
            <span>Nodi</span>
          </div>

          <div>
            <strong>{flowEditor.edges.length}</strong>
            <span>Collegamenti</span>
          </div>
        </div>


        {/* Strumenti grafici per i collegamenti */}
        <div className="flow-mouse-toolbar">
          <button
            type="button"
            className={flowTool === "select" ? "primary-btn" : "row-btn"}
            aria-pressed={flowTool === "select"}
            onClick={() => {
              setFlowTool("select");
              setFlowLinkSource(null);
              setSelectedFlowEdgeIndex(null);
              setSelectedFlowLabelIndex(null);
              setSelectedFlowPointIndex(null);
              setAddingFlowPoint(false);
              setFlowEdgeContextMenu(null);
            }}
          >
            Seleziona
          </button>

          <button
            type="button"
            className={flowTool === "connect" ? "primary-btn" : "row-btn"}
            aria-pressed={flowTool === "connect"}
            onClick={() => {
              if (editingEdge || editingNode) {
                const confirmed = window.confirm(
                  "È presente una modifica in corso.\n\n" +
                  "Passando alla modalità Collega nodi, " +
                  "le modifiche non ancora applicate verranno annullate.\n\n" +
                  "Vuoi continuare?"
                );

                if (!confirmed) return;
              }

              setFlowTool("connect");
              setFlowLinkSource(null);
              setSelectedFlowEdgeIndex(null);
              setSelectedFlowLabelIndex(null);
              setSelectedFlowPointIndex(null);
              setAddingFlowPoint(false);
              setFlowEdgeContextMenu(null);
              setEditingEdge(null);
              setEditingNode(null);
              setEdgeError("");
              setFlowError("");
            }}
          >
            Collega nodi
          </button>

          {flowTool === "connect" && (
            <>
              <span role="status">
                {flowLinkSource
                  ? `Origine: ${flowLinkSource} — seleziona la destinazione`
                  : "Seleziona il nodo di partenza"}
              </span>

              {flowLinkSource && (
                <button
                  type="button"
                  className="row-btn"
                  onClick={() => setFlowLinkSource(null)}
                >
                  Annulla selezione
                </button>
              )}
            </>
          )}
        </div>

        {/* Comandi rapidi sulla selezione grafica */}
        {flowTool === "select" &&
          selectedFlowEdgeIndex !== null &&
          flowEditor.edges[selectedFlowEdgeIndex] && (
          <div className="flow-mouse-toolbar">
            <span>
              Collegamento selezionato:{" "}
              {flowEditor.edges[selectedFlowEdgeIndex].source}
              {" → "}
              {flowEditor.edges[selectedFlowEdgeIndex].target}
            </span>

            <button
              type="button"
              className={addingFlowPoint ? "primary-btn" : "row-btn"}
              disabled={!!editingNode || !!editingEdge || flowSaving}
              onClick={() => {
                setAddingFlowPoint(prev => !prev);
                setSelectedFlowPointIndex(null);
                setFlowEdgeContextMenu(null);
              }}
            >
              {addingFlowPoint ? "Annulla aggiunta punto" : "Aggiungi punto"}
            </button>

            {selectedFlowPointIndex !== null &&
              Array.isArray(flowEditor.edges[selectedFlowEdgeIndex].points) &&
              flowEditor.edges[selectedFlowEdgeIndex].points[selectedFlowPointIndex] && (
              <button
                type="button"
                className="row-btn algorithm-delete-btn"
                disabled={!!editingNode || !!editingEdge || flowSaving}
                onClick={() => {
                  if (!window.confirm(
                    "Eliminare il punto intermedio selezionato?"
                  )) return;

                  const edgeIndex = selectedFlowEdgeIndex;
                  const pointIndex = selectedFlowPointIndex;

                  setFlowEditor(prev => ({
                    ...prev,
                    edges: prev.edges.map((edge, index) =>
                      index === edgeIndex
                        ? {
                            ...edge,
                            points: (edge.points || []).filter(
                              (_, i) => i !== pointIndex
                            )
                          }
                        : edge
                    )
                  }));

                  setSelectedFlowPointIndex(null);
                  setFlowError("");
                  markFlowAsModified();
                }}
              >
                Elimina punto selezionato
              </button>
            )}

            {selectedFlowLabelIndex === selectedFlowEdgeIndex &&
              flowEditor.edges[selectedFlowEdgeIndex].label && (
              <button
                type="button"
                className="row-btn algorithm-delete-btn"
                onClick={() => {
                  if (editingNode || editingEdge) {
                    setFlowError(
                      "Prima di eliminare un'etichetta, premi " +
                      "'Applica modifica' oppure 'Annulla' " +
                      "nella modifica attualmente aperta."
                    );
                    return;
                  }

                  if (!window.confirm(
                    "Eliminare soltanto l'etichetta del collegamento selezionato?"
                  )) return;

                  const index = selectedFlowEdgeIndex;

                  setFlowEditor(prev => ({
                    ...prev,
                    edges: prev.edges.map((edge, i) => {
                      if (i !== index) return edge;
                      const { labelX, labelY, ...rest } = edge;
                      return { ...rest, label: "" };
                    })
                  }));

                  setSelectedFlowLabelIndex(null);
                  setSelectedFlowEdgeIndex(null);
                  setFlowEdgeContextMenu(null);
                  markFlowAsModified();
                }}
              >
                Elimina etichetta selezionata
              </button>
            )}

            <button
              type="button"
              className="row-btn algorithm-delete-btn"
              onClick={() => {
                if (editingNode || editingEdge) {
                  setFlowError(
                    "Prima di eliminare un collegamento, premi " +
                    "'Applica modifica' oppure 'Annulla' " +
                    "nella modifica attualmente aperta."
                  );
                  return;
                }

                const index = selectedFlowEdgeIndex;
                const edge = flowEditor.edges[index];
                if (!edge) return;

                deleteFlowEdge(edge, index);
                setSelectedFlowEdgeIndex(null);
                setSelectedFlowLabelIndex(null);
                setSelectedFlowPointIndex(null);
                setAddingFlowPoint(false);
                setFlowEdgeContextMenu(null);
              }}
            >
              Elimina collegamento
            </button>

            <button
              type="button"
              className="row-btn"
              onClick={() => {
                setSelectedFlowEdgeIndex(null);
                setSelectedFlowLabelIndex(null);
                setSelectedFlowPointIndex(null);
                setAddingFlowPoint(false);
                setFlowEdgeContextMenu(null);
              }}
            >
              Annulla selezione
            </button>
          </div>
        )}

        {/* Crea o modifica etichetta con mouse */}
        {flowTool === "select" &&
          flowEdgeContextMenu &&
          flowEditor.edges[flowEdgeContextMenu.edgeIndex] && (
          <div
            className="flow-mouse-toolbar"
            role="group"
            aria-label="Menu contestuale collegamento"
          >
            <span>
              {flowEditor.edges[flowEdgeContextMenu.edgeIndex].source}
              {" → "}
              {flowEditor.edges[flowEdgeContextMenu.edgeIndex].target}
            </span>

            <button
              type="button"
              className="primary-btn"
              onClick={() => {
                if (editingNode || editingEdge) {
                  setFlowError(
                    "Prima di modificare un'etichetta, premi " +
                    "'Applica modifica' oppure 'Annulla' " +
                    "nella modifica attualmente aperta."
                  );
                  return;
                }

                const index = flowEdgeContextMenu.edgeIndex;
                const edge = flowEditor.edges[index];
                if (!edge) return;

                const entered = window.prompt(
                  edge.label
                    ? "Modifica il testo dell'etichetta:"
                    : "Inserisci il testo della nuova etichetta:",
                  edge.label || ""
                );

                if (entered === null) return;

                const label = entered.trim();

                if (!label) {
                  setFlowError(
                    "Il testo dell'etichetta non può essere vuoto. " +
                    "Usa 'Elimina etichetta' per rimuoverla."
                  );
                  return;
                }

                const { x, y } = flowEdgeContextMenu.position;

                setFlowEditor(prev => ({
                  ...prev,
                  edges: prev.edges.map((item, i) =>
                    i === index
                      ? { ...item, label, labelX: x, labelY: y }
                      : item
                  )
                }));

                setSelectedFlowEdgeIndex(index);
                setSelectedFlowLabelIndex(index);
                setFlowEdgeContextMenu(null);
                setFlowError("");
                markFlowAsModified();
              }}
            >
              {flowEditor.edges[flowEdgeContextMenu.edgeIndex].label
                ? "Modifica etichetta"
                : "Aggiungi etichetta"}
            </button>

            <button
              type="button"
              className="row-btn"
              onClick={() => setFlowEdgeContextMenu(null)}
            >
              Chiudi menu
            </button>
          </div>
        )}

        {/* Anteprima grafica della flowchart in locale */}
<div className="flow-admin-preview">
  <AlgorithmFlow
    algorithm={{
      ...flowEditor.algorithm,
      nodes: previewNodes,
      edges: previewEdges
    }}
    onNodeClick={flowTool === "connect" ? handleFlowNodeClick : null}
    selectedNodeId={flowTool === "connect" ? flowLinkSource : null}
    selectedEdgeIndex={flowTool === "select" ? selectedFlowEdgeIndex : null}
    selectedEdgeLabelIndex={flowTool === "select" ? selectedFlowLabelIndex : null}
    selectedEdgePointIndex={selectedFlowPointIndex}
    addingSelectedEdgePoint={addingFlowPoint}
    onSelectedEdgePointClick={flowTool === "select" ? (edgeIndex, pointIndex) => {
      setSelectedFlowEdgeIndex(edgeIndex);
      setSelectedFlowPointIndex(pointIndex);
      setSelectedFlowLabelIndex(null);
      setFlowEdgeContextMenu(null);
    } : null}
    onSelectedEdgePointAdd={
      flowTool === "select" &&
      !editingNode &&
      !editingEdge &&
      !flowSaving
        ? (edgeIndex, insertIndex, x, y, basePoints) => {
            if (!Number.isFinite(x) || !Number.isFinite(y)) return;

            setFlowEditor(prev => ({
              ...prev,
              edges: prev.edges.map((edge, index) => {
                if (index !== edgeIndex) return edge;

                const points = [...(
                  Array.isArray(edge.points) && edge.points.length
                    ? edge.points
                    : basePoints || []
                )];

                const safeIndex = Math.max(
                  0,
                  Math.min(insertIndex, points.length)
                );

                points.splice(safeIndex, 0, { x, y });
                return { ...edge, points };
              })
            }));

            setSelectedFlowPointIndex(null);
            setAddingFlowPoint(false);
            setFlowError("");
            markFlowAsModified();
          }
        : null
    }
    onEdgeClick={flowTool === "select" ? edgeIndex => {
      setSelectedFlowEdgeIndex(edgeIndex);
      setSelectedFlowLabelIndex(null);
      setSelectedFlowPointIndex(null);
      setAddingFlowPoint(false);
      setFlowEdgeContextMenu(null);
    } : null}
    onEdgeLabelClick={flowTool === "select" ? edgeIndex => {
      setSelectedFlowEdgeIndex(edgeIndex);
      setSelectedFlowLabelIndex(edgeIndex);
      setSelectedFlowPointIndex(null);
      setAddingFlowPoint(false);
      setFlowEdgeContextMenu(null);
    } : null}
    onSelectedEdgePointMove={
      flowTool === "select" &&
      !editingNode &&
      !editingEdge &&
      !flowSaving
        ? (edgeIndex, pointIndex, x, y) => {
            if (!Number.isFinite(x) || !Number.isFinite(y)) return;

            setFlowEditor(prev => ({
              ...prev,
              edges: prev.edges.map((edge, index) => {
                if (index !== edgeIndex || !Array.isArray(edge.points)) {
                  return edge;
                }

                return {
                  ...edge,
                  points: edge.points.map((point, index) =>
                    index === pointIndex
                      ? { ...point, x, y }
                      : point
                  )
                };
              })
            }));

            markFlowAsModified();
          }
        : null
    }
    onEdgeLabelMove={
      flowTool === "select" &&
      !editingNode &&
      !editingEdge &&
      !flowSaving
        ? (edgeIndex, x, y) => {
            if (!Number.isFinite(x) || !Number.isFinite(y)) return;

            setFlowEditor(prev => ({
              ...prev,
              edges: prev.edges.map((edge, index) =>
                index === edgeIndex && edge.label
                  ? { ...edge, labelX: x, labelY: y }
                  : edge
              )
            }));

            markFlowAsModified();
          }
        : null
    }
    onEdgeContextMenu={flowTool === "select" ? (edgeIndex, position) => {
      setSelectedFlowEdgeIndex(edgeIndex);
      setSelectedFlowLabelIndex(null);
      setSelectedFlowPointIndex(null);
      setAddingFlowPoint(false);
      setFlowEdgeContextMenu({ edgeIndex, position });
    } : null}
  />
</div>

        {flowError && (
          <div className="algorithm-form-error">
            {flowError}
          </div>
        )}

        
{!editingEdge && (
  <>
    <div className="panel-head">
      <div>
        <span className="eyebrow">NODI</span>
        <h3>Nodi della flowchart</h3>
      </div>

      <button
        type="button"
        className="primary-btn"
        onClick={addFlowNode}
      >
        + Aggiungi nodo
      </button>
    </div>

    <div className="table-wrap">
          <table>
            <thead>
   <tr>
    <th>ID</th>
    <th>TIPO</th>
    <th>TESTO</th>
    <th>POSIZIONE</th>
    <th>AZIONI</th>
  </tr>
</thead>

            <tbody>
              {flowEditor.nodes.length === 0 && (
                <tr>
                  <td colSpan="5" className="empty-row">
                    Nessun nodo presente.
                  </td>
                </tr>
              )}

              {flowEditor.nodes.map(node => (
                <tr key={node.id}>
                  <td>
                    <b>{node.id}</b>
                  </td>

                  <td>
                    {node.type || "—"}
                  </td>

                  <td>
                    {node.text || "—"}
                  </td>

                  <td>
                    x: {node.x ?? "—"} · y: {node.y ?? "—"}
                  </td>

      <td>
  <div className="algorithm-admin-actions">

    <button
      type="button"
      className="row-btn"
      onClick={() => editFlowNode(node)}
    >
      Modifica
    </button>

    <button
      type="button"
      className="row-btn algorithm-delete-btn"
      onClick={() => deleteFlowNode(node)}
    >
      Elimina
    </button>

  </div>
</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>


  </>
)}

{!editingNode && (
<div className="flow-edges-section">

  <div className="panel-head">

  <div>
    <span className="eyebrow">
      COLLEGAMENTI
    </span>
    <h3>
      Collegamenti della flowchart
    </h3>
  </div>

  <button
    type="button"
    className="primary-btn"
    onClick={addFlowEdge}
  >
    + Aggiungi collegamento
  </button>

</div>

  <div className="table-wrap">
    <table>
      <thead>
        <tr>
          <th>#</th>
          <th>ORIGINE</th>
          <th>DESTINAZIONE</th>
          <th>ETICHETTA</th>
          <th>PUNTI</th>
          <th>AZIONI</th>
        </tr>
      </thead>

      <tbody>

        {flowEditor.edges.length === 0 && (
          <tr>
            <td colSpan="6" className="empty-row">
              Nessun collegamento presente.
            </td>
          </tr>
        )}

        {flowEditor.edges.map((edge, index) => (
          <tr key={`${edge.source}-${edge.target}-${index}`}>

            <td>
              {index + 1}
            </td>

            <td>
              <b>{edge.source}</b>
            </td>

            <td>
              <b>{edge.target}</b>
            </td>

            <td>
              {edge.label || "—"}
            </td>

            <td> 
  {Array.isArray(edge.points) && edge.points.length > 0 ? ( //In questo modo oltre il numero di punti intermedi vengono visualizzate anche le coordinate
    <div className="edge-points-list">

      <strong>
        {edge.points.length} {edge.points.length === 1 ? "punto" : "punti"}
      </strong>

      {edge.points.map((point, pointIndex) => (
        <div
          key={pointIndex}
          className="edge-point-item"
        >
          P{pointIndex + 1}: x={point.x ?? "—"}, y={point.y ?? "—"}
        </div>
      ))}

    </div>
  ) : (
    <span>0</span>
  )}
</td>

            <td>
  <div className="algorithm-admin-actions">

    <button //Tasto modifica collegamento
      type="button"
      className="row-btn"
      onClick={() => editFlowEdge(edge, index)}
    >
      Modifica
    </button>

    <button //Tasto elimina collegamento
      type="button"
      className="row-btn algorithm-delete-btn"
      onClick={() => deleteFlowEdge(edge, index)}
    >
      Elimina
    </button>

  </div>
</td>

          </tr>
        ))}

      </tbody>
    </table>
    
  </div>

{editingEdge && (
  <div className="algorithm-form-panel">

    <div className="panel-head">
      <div>
        <span className="eyebrow">
          MODIFICA COLLEGAMENTO
        </span>

        <h3>
          {editingEdge.source} → {editingEdge.target}
        </h3>
      </div>
    </div>

    <label>
  <span>Lato origine</span>

  <select
    value={editingEdge.sourceSide || "bottom"}
    onChange={e =>
      setEditingEdge(prev => ({
        ...prev,
        sourceSide: e.target.value
      }))
    }
  >
    <option value="top">Alto</option>
    <option value="right">Destra</option>
    <option value="bottom">Basso</option>
    <option value="left">Sinistra</option>
  </select>
</label>

<label>
  <span>Lato destinazione</span>

  <select
    value={editingEdge.targetSide || "top"}
    onChange={e =>
      setEditingEdge(prev => ({
        ...prev,
        targetSide: e.target.value
      }))
    }
  >
    <option value="top">Alto</option>
    <option value="right">Destra</option>
    <option value="bottom">Basso</option>
    <option value="left">Sinistra</option>
  </select>
</label>

    <div className="algorithm-form-grid">

      <label>
        <span>Origine</span>

        <select
          value={editingEdge.source || ""}
          onChange={e =>
            setEditingEdge({
              ...editingEdge,
              source: e.target.value
            })
          }
        >
          <option value="">
            Seleziona nodo...
          </option>

          {flowEditor.nodes.map(node => (
            <option
              key={node.id}
              value={node.id}
            >
              {node.id} — {(
                (node.text || "Senza testo")
                  .replace(/\s+/g, " ")
                  .trim()
                  .slice(0, 60)
              )}{(node.text || "").replace(/\s+/g, " ").trim().length > 60 ? "..." : ""}
            </option>
          ))}

        </select>
      </label>


      <label>
        <span>Destinazione</span>

        <select
          value={editingEdge.target || ""}
          onChange={e =>
            setEditingEdge({
              ...editingEdge,
              target: e.target.value
            })
          }
        >
          <option value="">
            Seleziona nodo...
          </option>

          {flowEditor.nodes.map(node => (
            <option
              key={node.id}
              value={node.id}
            >
              {node.id} — {(
                (node.text || "Senza testo")
                  .replace(/\s+/g, " ")
                  .trim()
                  .slice(0, 60)
              )}{(node.text || "").replace(/\s+/g, " ").trim().length > 60 ? "..." : ""}
            </option>
          ))}

        </select>
      </label>


      <label className="algorithm-title-field">
        <span>Etichetta</span>

        <input
          type="text"
          value={editingEdge.label || ""}
          placeholder="Es. Sì, No, Positivo, Se indicato..."
          onChange={e =>
            setEditingEdge({
              ...editingEdge,
              label: e.target.value
            })
          }
        />

        <small>
          Campo facoltativo. Puoi inserire qualsiasi testo oppure lasciarlo vuoto.
        </small>
      </label>

      <label>
  <span>Posizione etichetta</span>

  <select
    value={
      editingEdge.labelX !== undefined &&
      editingEdge.labelY !== undefined
        ? "manual"
        : "auto"
    }
    onChange={e => {
      if (e.target.value === "auto") {
        setEditingEdge(prev => {
          const {
            labelX,
            labelY,
            ...rest
          } = prev;

          return rest;
        });
      } else {
        setEditingEdge(prev => ({
          ...prev,
          labelX: prev.labelX ?? 0,
          labelY: prev.labelY ?? 0
        }));
      }

      setEdgeError("");
    }}
  >
    <option value="auto">
      Automatica
    </option>

    <option value="manual">
      Manuale
    </option>
  </select>
</label>
{editingEdge.labelX !== undefined &&
 editingEdge.labelY !== undefined && (
  <>
    <label>
      <span>Etichetta X</span>

      <input
        type="number"
        value={editingEdge.labelX}
        onChange={e =>
          setEditingEdge(prev => ({
            ...prev,
            labelX: e.target.value
          }))
        }
      />
    </label>

    <label>
      <span>Etichetta Y</span>

      <input
        type="number"
        value={editingEdge.labelY}
        onChange={e =>
          setEditingEdge(prev => ({
            ...prev,
            labelY: e.target.value
          }))
        }
      />
    </label>
  </>
)}

<div className="edge-points-editor">

  <span className="edge-points-title"> 
    Punti intermedi
  </span>

  {(!editingEdge.points ||
    editingEdge.points.length === 0) && (
    <div className="edge-points-empty">
      Nessun punto intermedio.
    </div>
  )}

  {(editingEdge.points || []).map((point, pointIndex) => (
    <div
      key={pointIndex}
      className="edge-point-editor-row"
    >

      <strong>
        P{pointIndex + 1}
      </strong>

      <label>
        <span>X</span>
        <input
          type="number"
          value={point.x ?? ""}
          onChange={e =>
            updateEdgePoint(
              pointIndex,
              "x",
              e.target.value
            )
          }
        />
      </label>

      <label>
        <span>Y</span>
        <input
          type="number"
          value={point.y ?? ""}
          onChange={e =>
            updateEdgePoint(
              pointIndex,
              "y",
              e.target.value
            )
          }
        />
      </label>

      <div className="edge-point-nudge">

  <button
    type="button"
    className="row-btn"
    onClick={() =>
      nudgeEdgePoint(pointIndex, -10, 0)
    }
    title="Sposta 10 px a sinistra"
  >
    ←
  </button>

  <button
    type="button"
    className="row-btn"
    onClick={() =>
      nudgeEdgePoint(pointIndex, 0, -10)
    }
    title="Sposta 10 px in alto"
  >
    ↑
  </button>

  <button
    type="button"
    className="row-btn"
    onClick={() =>
      nudgeEdgePoint(pointIndex, 0, 10)
    }
    title="Sposta 10 px in basso"
  >
    ↓
  </button>

  <button
    type="button"
    className="row-btn"
    onClick={() =>
      nudgeEdgePoint(pointIndex, 10, 0)
    }
    title="Sposta 10 px a destra"
  >
    →
  </button>

</div>

<div className="edge-point-order-actions">

  <button /* Pulsanti per modificare l'ordine dei punti intermedi */
    type="button"
    className="row-btn"
    disabled={pointIndex === 0}
    onClick={() =>
      moveEdgePoint(pointIndex, "up")
    }
    title="Sposta il punto prima"
  >
    ↑ Su
  </button>

  <button
    type="button"
    className="row-btn"
    disabled={
      pointIndex ===
      (editingEdge.points || []).length - 1
    }
    onClick={() =>
      moveEdgePoint(pointIndex, "down")
    }
    title="Sposta il punto dopo"
  >
    ↓ Giù
  </button>

</div>

      <button
        type="button"
        className="row-btn algorithm-delete-btn"
        onClick={() => deleteEdgePoint(pointIndex)}
      >
        Elimina
      </button>

    </div>
  ))}

  <button
    type="button"
    className="row-btn"
    onClick={addEdgePoint}
  >
    + Aggiungi punto
  </button>

</div>

    </div>

{edgeError && (
  <div className="error error-in-form">
    {edgeError}
  </div>
)}

{/* Anteprima in tempo reale durante la modifica del collegamento */}
<div className="edge-edit-preview">

  <div className="edge-edit-preview-header">
    <strong>Anteprima modifica collegamento</strong>
    <span>
      {editingEdge.source} → {editingEdge.target}
    </span>
  </div>

  <div className="edge-edit-preview-canvas">
    <AlgorithmFlow
  algorithm={{
    ...flowEditor.algorithm,
    nodes: previewNodes, // Nodi d'anteprima
    edges: previewEdges //Collegamenti d'anteprima 
  }}
  focusEdge={editingEdge}
  editableEdgeIndex={editingEdge._index}
  onEdgePointAdd={(insertIndex, x, y, basePoints) => {
    if (!Number.isFinite(x) || !Number.isFinite(y)) return;

    setEditingEdge(prev => {
      if (!prev) return prev;

      const points = [...(
        (prev.points || []).length > 0
          ? prev.points
          : basePoints || []
      )];
      const safeIndex = Math.max(
        0,
        Math.min(insertIndex, points.length)
      );

      points.splice(safeIndex, 0, { x, y });

      return {
        ...prev,
        points
      };
    });

    setEdgeError("");
  }}
  onEdgePointMove={(pointIndex, x, y) => {
    setEditingEdge(prev => {
      if (!prev) return prev;

      return {
        ...prev,
        points: (prev.points || []).map((point, index) =>
          index === pointIndex
            ? { ...point, x, y }
            : point
        )
      };
    });

    setEdgeError("");
  }}
/>
  </div>

</div>

    <div className="algorithm-form-actions">

      <button
        type="button"
        className="row-btn"
        onClick={cancelFlowEdgeEdit}
      >
        Annulla
      </button>

      <button
        type="button"
        className="primary-btn"
        onClick={applyFlowEdgeEdit}
      >
        Applica modifica
      </button>

    </div>

  </div>
)}

</div>

)}

{editingNode && (
  <div className="algorithm-form-panel">

    <div className="panel-head">
      <div>
        <span className="eyebrow">
          MODIFICA NODO
        </span>

        <h3>{editingNode.id}</h3>
      </div>
    </div>

    <div className="algorithm-form-grid">

      <label>
        <span>Tipo</span>

        <select
          value={editingNode.type || "action"}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              type: e.target.value
            })
          }
        >
          <option value="entry">Entry</option>
          <option value="action">Action</option>
          <option value="criteria">Criteria</option>
          <option value="decision">Decision</option>
          <option value="treatment">Treatment</option>
          <option value="warning">Warning</option>
          <option value="exit">Exit</option>
        </select>
      </label>

      <label>
        <span>ID nodo</span>

        <input
          type="text"
          value={editingNode.id || ""}
          disabled
        />
      </label>

      
      <label className="algorithm-title-field">
        <span>Colore nodo</span>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap"
        }}>
          <input
            type="color"
            aria-label="Colore personalizzato nodo"
            value={editingNode.color || "#f1f3f5"}
            onChange={e =>
              setEditingNode(prev => ({
                ...prev,
                color: e.target.value
              }))
            }
            style={{
              width: 55,
              height: 38,
              padding: 2,
              cursor: "pointer"
            }}
          />

          <span>
            {editingNode.color || "Colore predefinito"}
          </span>

          <button
            type="button"
            className="row-btn"
            onClick={() =>
              setEditingNode(prev => {
                const updated = { ...prev };
                delete updated.color;
                return updated;
              })
            }
          >
            Ripristina predefinito
          </button>
        </div>
      </label>

      <label className="algorithm-title-field">
        <span>Testo</span>

        <textarea
          rows="6"
          value={editingNode.text || ""}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              text: e.target.value
            })
          }
        />
      </label>

      <label>
        <span>Posizione X</span>

        <input
          type="number"
          value={editingNode.x ?? ""}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              x: Number(e.target.value)
            })
          }
        />
      </label>

      <label>
        <span>Posizione Y</span>

        <input
          type="number"
          value={editingNode.y ?? ""}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              y: Number(e.target.value)
            })
          }
        />
      </label>

      <div className="node-nudge-controls">

  <span className="node-nudge-label">
    Spostamento rapido
  </span>

  <div className="node-nudge-buttons">

    <button
      type="button"
      className="row-btn"
      onClick={() => nudgeFlowNode(-10, 0)}
      title="Sposta il nodo 10 px a sinistra"
    >
      ←
    </button>

    <button
      type="button"
      className="row-btn"
      onClick={() => nudgeFlowNode(0, -10)}
      title="Sposta il nodo 10 px in alto"
    >
      ↑
    </button>

    <button
      type="button"
      className="row-btn"
      onClick={() => nudgeFlowNode(0, 10)}
      title="Sposta il nodo 10 px in basso"
    >
      ↓
    </button>

    <button
      type="button"
      className="row-btn"
      onClick={() => nudgeFlowNode(10, 0)}
      title="Sposta il nodo 10 px a destra"
    >
      →
    </button>

  </div>

</div>

      <label>
        <span>Larghezza</span>

        <input
          type="number"
          value={editingNode.width ?? ""}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              width: Number(e.target.value)
            })
          }
        />
      </label>

      <label>
        <span>Altezza</span>

        <input
          type="number"
          value={editingNode.height ?? ""}
          onChange={e =>
            setEditingNode({
              ...editingNode,
              height: Number(e.target.value)
            })
          }
        />
      </label>

    </div>

    {/* Anteprima in tempo reale durante la modifica del nodo */}
<div className="edge-edit-preview">

  <div className="edge-edit-preview-header">
    <strong>Anteprima modifica nodo</strong>

    <span>
      {editingNode.id}
    </span>
  </div>

  <div className="edge-edit-preview-canvas">
    <AlgorithmFlow
      algorithm={{
        ...flowEditor.algorithm,
        nodes: previewNodes,
        edges: flowEditor.edges
      }}
    />
  </div>

</div>

    <div className="algorithm-form-actions">

      <button
        type="button"
        className="row-btn"
        onClick={cancelFlowNodeEdit}
      >
        Annulla
      </button>

      <button
        type="button"
        className="primary-btn"
        onClick={applyFlowNodeEdit}
      >
        Applica modifica
      </button>

    </div>

  </div>
)}

      </section>
    )}

  </>
  
)}



   {section==="documents"&&<>
  {can("admin.documents.write")&&
    <div className="upload-panel">
      <div>
        <Upload size={22}/>
        <b>Carica nuova procedura</b>
        <small>PDF o DOCX · massimo 15MB · estrazione testo automatica</small>
      </div>

      <div style={{display:"flex",gap:8,alignItems:"center"}}>
        {can("admin.users.write") && can("admin.roles.write") && (
          <button
            data-testid="reindex-documents-button"
            type="button"
            className="row-btn"
            onClick={reindexDocs}
            disabled={reindexing}
          >
            {reindexing?"Reindicizzo…":"Reindicizza embeddings"}
          </button>
        )}

        <label
          className="primary-btn"
          aria-disabled={uploadingDocument}
          aria-busy={uploadingDocument}
          style={{
            opacity: uploadingDocument ? 0.6 : 1,
            cursor: uploadingDocument ? "not-allowed" : "pointer"
          }}
        >
          <Upload size={16}/>
          {uploadingDocument ? "Caricamento in corso..." : "Seleziona file"}
          <input
            data-testid="document-upload-input"
            type="file"
            accept=".pdf,.docx,.doc"
            disabled={uploadingDocument}
            hidden
          />
        </label>
      </div>
    </div>
  }

  {can("admin.users.write")&&can("admin.roles.write")&&reindexMessage&&
    <div className="success" data-testid="reindex-success">
      {reindexMessage}
    </div>
  }

  {can("admin.users.write")&&can("admin.roles.write")&&reindexError&&
    <div className="error" data-testid="reindex-error">
      {reindexError}
    </div>
  }

  {can("admin.documents.write")&&docForm.open&&
    <form
      className="user-create-form"
      data-testid="doc-edit-form"
      onSubmit={submitDoc}
    >
      <div className="user-create-heading">
        <span className="eyebrow">MODIFICA DOCUMENTO</span>
        <b>{docForm.title||"Documento"}</b>
        <small>
          I metadati vengono aggiornati anche nell'indice di ricerca.
        </small>
      </div>

      <div className="user-create-grid">
        <label>
          Titolo
          <input
            data-testid="doc-title-input"
            required
            value={docForm.title}
            onChange={e=>updateDocField("title",e.target.value)}
          />
        </label>

        <label>
          Identificativo
          <input
            data-testid="doc-identifier-input"
            value={docForm.identifier}
            onChange={e=>updateDocField("identifier",e.target.value)}
            placeholder="Es. PRC-118-042"
          />
        </label>

        <label>
          Versione
          <input
            data-testid="doc-version-input"
            value={docForm.version}
            onChange={e=>updateDocField("version",e.target.value)}
            placeholder="Es. 1.2"
          />
        </label>

        <label>
          Categoria
          <input
            data-testid="doc-category-input"
            value={docForm.category}
            onChange={e=>updateDocField("category",e.target.value)}
          />
        </label>

        <label>
          Stato
          <select
            data-testid="doc-status-select"
            value={docForm.status}
            onChange={e=>updateDocField("status",e.target.value)}
          >
            <option value="active">Attivo</option>
            <option value="archived">Archiviato</option>
            <option value="draft">Bozza</option>
          </select>
        </label>

        <label className="span-2">
          Descrizione
          <textarea
            data-testid="doc-description-input"
            rows="2"
            value={docForm.description}
            onChange={e=>updateDocField("description",e.target.value)}
          />
        </label>
      </div>

      {docError&&
        <div className="error" data-testid="doc-error">
          {docError}
        </div>
      }

      <div className="user-create-actions">
        <button
          type="button"
          data-testid="cancel-doc-button"
          onClick={closeDocForm}
        >
          Annulla
        </button>

        <button
          data-testid="doc-submit-button"
          className="primary-btn"
          disabled={savingDoc}
          type="submit"
        >
          {savingDoc?"Salvataggio…":"Salva modifiche"}
        </button>
      </div>
    </form>
  }

  {can("admin.documents.write")&&docMessage&&
    <div className="success" data-testid="doc-success">
      {docMessage}
    </div>
  }

  {can("admin.documents.write")&&docError&&!docForm.open&&
    <div className="error" data-testid="doc-error-inline">
      {docError}
    </div>
  }

  <div className="table-wrap">
    <table>
      <thead>
        <tr>
          <th>DOCUMENTO</th>
          <th>IDENTIFICATIVO</th>
          <th>VERSIONE</th>
          <th>STATO</th>
          <th>AGGIORNATO</th>
          <th>AZIONI</th>
        </tr>
      </thead>

      <tbody>
        {docs.length===0&&
          <tr>
            <td colSpan="6" className="empty-row">
              Nessun documento caricato.
            </td>
          </tr>
        }

        {docs.map(d=>
          <tr key={d.id} data-testid={`admin-document-${d.id}`}>
            <td>
              <b>{d.title}</b>
              <small>{d.category||"—"} · {d.file_name||"file"}</small>
            </td>

            <td data-testid={`doc-identifier-${d.id}`}>
              {d.identifier||"—"}
            </td>

            <td>v{d.version}</td>

            <td>
              <span className={d.status==="active"?"table-status":"table-status off"}>
                <i/>
                {d.status==="active"
                  ?"Attivo"
                  :d.status==="archived"
                    ?"Archiviato"
                    :"Bozza"}
              </span>
            </td>

            <td>
              {new Date(d.updated_at).toLocaleDateString("it-IT")}
            </td>

            <td className="row-actions">
              <button
                data-testid={`download-doc-${d.id}-button`}
                className="row-btn"
                type="button"
                onClick={()=>openDocumentBlob(d.id)}
              >
                <FileText size={12}/> Apri
              </button>

              {can("admin.documents.write")&&<>
                <button
                  data-testid={`edit-doc-${d.id}-button`}
                  className="row-btn"
                  type="button"
                  onClick={()=>openEditDoc(d)}
                >
                  <Edit2 size={12}/> Modifica
                </button>

                <button
                  data-testid={`cycle-doc-${d.id}-button`}
                  className="row-btn"
                  type="button"
                  onClick={()=>cycleDocStatus(d)}
                >
                  {d.status==="active"
                    ?"Archivia"
                    :d.status==="archived"
                      ?"Bozza"
                      :"Attiva"}
                </button>

                <button
                  data-testid={`delete-doc-${d.id}-button`}
                  className="row-btn danger"
                  type="button"
                  onClick={()=>deleteDoc(d)}
                >
                  <Trash2 size={12}/> Elimina
                </button>
              </>}
            </td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
</>}

   {section==="users"&&<>
  <div className="admin-toolbar">
    {can("admin.users.write")&&
      <button
        data-testid="open-create-user-button"
        type="button"
        className="primary-btn"
        onClick={()=>userForm.open?closeUserForm():openCreateUser()}
      >
        <Plus size={16}/>
        {userForm.open&&userForm.mode==="create"?"Chiudi":"Nuovo utente"}
      </button>
    }
    {isRealAdmin && (
      <button
        type="button"
        className="row-btn danger"
        data-testid="revoke-all-sessions-button"
        onClick={revokeAllSessions}
      >
        Disconnetti tutti
      </button>
    )}
    <span>{users.length} account gestiti</span>
  </div>

  {can("admin.users.write")&&userForm.open&&
    <form
      className="user-create-form"
      data-testid="create-user-form"
      onSubmit={submitUser}
    >
      <div className="user-create-heading"><span className="eyebrow">{userForm.mode==="edit"?"MODIFICA ACCOUNT":"CREAZIONE ACCOUNT"}</span><b>{userForm.mode==="edit"?userForm.email:"Nuovo utente"}</b><small>{userForm.mode==="edit"?"L’email non è modificabile. Lascia la password vuota per non cambiarla.":"Scegli se inviare un link di attivazione o impostare manualmente la password."}</small></div>
        <div className="user-create-grid">
          <label>Nome e cognome<input data-testid="create-user-name-input" required minLength="2" value={userForm.name} onChange={e=>updateUserField("name",e.target.value)} placeholder="Es. Maria Rossi"/></label>
          <label>Email<input data-testid="create-user-email-input" required type="email" value={userForm.email} onChange={e=>updateUserField("email",e.target.value)} placeholder="nome.cognome@centrale.it" disabled={userForm.mode==="edit"}/></label>
          <label>
  Ruolo
  <select
    data-testid="create-user-role-select"
    value={userForm.role}
    onChange={e=>updateUserField("role",e.target.value)}
  >
    {roles
      .filter(r => (r.active !== false || r.key === userForm.role) && (isRealAdmin || r.key !== "admin"))
      .map(r => (
        <option key={r.key} value={r.key}>
          {r.name}
        </option>
      ))}
  </select>
</label>
          {userForm.mode==="create"&&
            <label className="span-2">
              Modalità di attivazione
              <select
                data-testid="create-user-activation-mode"
                value={userForm.activation_mode}
                onChange={e=>updateUserField("activation_mode",e.target.value)}
              >
                <option value="email">Invia email di attivazione</option>
                <option value="manual">Attivazione manuale immediata</option>
              </select>
            </label>
          }
          {(userForm.mode==="edit"||userForm.activation_mode==="manual")&&
            <label>
              {userForm.mode==="edit"
                ? userForm.activation_status==="pending"
                  ? "Password iniziale per attivazione"
                  : "Nuova password (opzionale)"
                : "Password iniziale"}
              <input
                data-testid="create-user-password-input"
                required={
                  userForm.mode==="create"||
                  (userForm.activation_status==="pending"&&userForm.active)
                }
                minLength="8"
                type="password"
                value={userForm.password}
                onChange={e=>updateUserField("password",e.target.value)}
                placeholder="Almeno 8 caratteri"
                autoComplete="new-password"
              />
            </label>
          }
          {userForm.mode==="create"&&userForm.activation_mode==="email"&&
            <small style={{gridColumn:"1 / -1",color:"#687181"}}>
              L'utente riceverà un collegamento valido 24 ore per impostare la password.
            </small>
          }
          {userForm.mode==="edit"&&<label className="inline-check"><input data-testid="edit-user-active-checkbox" type="checkbox" checked={userForm.active} onChange={e=>updateUserField("active",e.target.checked)}/> Account attivo</label>}
        </div>
        {userError&&<div className="error" data-testid="create-user-error">{userError}</div>}
        <div className="user-create-actions">
          <button type="button" data-testid="cancel-create-user-button" onClick={closeUserForm}>Annulla</button>
          <button data-testid="create-user-submit-button" className="primary-btn" disabled={savingUser} type="submit">{savingUser?"Salvataggio…":userForm.mode==="edit"?"Salva modifiche":"Crea account"}</button>
        </div>
      </form>}
      {userMessage&&<div className="success" data-testid="create-user-success">{userMessage}</div>}
      <div className="table-wrap"><table><thead><tr><th>UTENTE</th><th>RUOLO</th><th>STATO</th><th>CREATO</th><th>AZIONI</th></tr></thead><tbody>{users.map(u=><tr key={u.id} data-testid={`admin-user-${u.id}`}><td><b>{u.name}</b><small>{u.email}</small></td><td>
  <span className="role-tag">
    {roles.find(r => r.key === u.role)?.name || u.role}
  </span>
</td><td><span className={u.active?"table-status":"table-status off"}><i/>{u.activation_status==="pending"?"In attesa di attivazione":u.active?"Attivo":"Disabilitato"}</span></td><td>{new Date(u.created_at).toLocaleDateString("it-IT")}</td><td className="row-actions">
  {can("admin.users.write") && (isRealAdmin || u.role !== "admin") ? (
    <>
      <button
        data-testid={`edit-user-${u.id}-button`}
        className="row-btn"
        type="button"
        onClick={()=>openEditUser(u)}
      >
        <Edit2 size={12}/> Modifica
      </button>

      {u.activation_status==="pending"&&
        <button
          data-testid={`resend-activation-${u.id}-button`}
          className="row-btn"
          type="button"
          onClick={()=>resendActivation(u)}
        >
          Reinvia email
        </button>
      }

      {u.activation_status==="pending"&&
        <button
          data-testid={`cancel-activation-${u.id}-button`}
          className="row-btn danger"
          type="button"
          onClick={()=>cancelActivation(u)}
        >
          Annulla attivazione
        </button>
      }

      {u.activation_status!=="pending"&&u.activation_status!=="disabled"&&
        <button
          data-testid={`toggle-user-${u.id}-button`}
          className="row-btn"
          type="button"
          onClick={()=>toggleUser(u.id)}
        >
          {u.active?"Disabilita":"Riattiva"}
        </button>
      }

      <button
        data-testid={`delete-user-${u.id}-button`}
        className="row-btn danger"
        type="button"
        onClick={()=>deleteUser(u)}
      >
        <Trash2 size={12}/> Elimina
      </button>
    </>
  ) : (
    <span style={{fontSize:12,opacity:.65}}>
      Sola lettura
    </span>
  )}
</td></tr>)}</tbody></table></div>
    </>}
    {section==="roles"&&<>
  <div className="admin-toolbar">
    {can("admin.roles.write")&&
  <button
    data-testid="open-create-role-button"
    type="button"
    className="primary-btn"
    onClick={()=>roleForm.open ? closeRoleForm() : openCreateRole()}
  >
    <Plus size={16}/>
    {roleForm.open && roleForm.mode==="create" ? "Chiudi" : "Nuovo ruolo"}
  </button>
}

    <span>
      {roles.length} ruoli · {permissions.length} permessi disponibili
    </span>
  </div>

  {can("admin.roles.write")&&roleForm.open&&
    <form
      className="user-create-form"
      data-testid="role-form"
      onSubmit={submitRole}
    >
      <div className="user-create-heading">
        <span className="eyebrow">
          {roleForm.mode==="edit" ? "MODIFICA RUOLO" : "NUOVO RUOLO"}
        </span>

        <b>
          {roleForm.mode==="edit"
            ? roleForm.name
            : "Crea un nuovo ruolo"}
        </b>

        <small>
          Seleziona esclusivamente i permessi necessari agli utenti
          appartenenti a questo ruolo.
        </small>
      </div>

      <div className="user-create-grid">

        <label>
          Chiave ruolo
          <input
            data-testid="role-key-input"
            required
            value={roleForm.key}
            disabled={roleForm.mode==="edit"}
            onChange={e=>
              updateRoleField(
                "key",
                e.target.value.toLowerCase().replace(/[^a-z0-9_]/g,"")
              )
            }
            placeholder="es. supervisore"
          />
        </label>

        <label>
          Nome
          <input
            data-testid="role-name-input"
            required
            value={roleForm.name}
            onChange={e=>updateRoleField("name",e.target.value)}
            placeholder="Es. Supervisore"
          />
        </label>

        <label className="span-2">
          Descrizione
          <textarea
            data-testid="role-description-input"
            rows="2"
            value={roleForm.description}
            onChange={e=>updateRoleField("description",e.target.value)}
            placeholder="Descrivi le funzioni associate a questo ruolo"
          />
        </label>

        <label>
          Stato
          <select
            data-testid="role-active-select"
            value={roleForm.active ? "active" : "inactive"}
            onChange={e=>
              updateRoleField("active",e.target.value==="active")
            }
          >
            <option value="active">Attivo</option>
            <option value="inactive">Disattivato</option>
          </select>
        </label>

      </div>

      <div style={{marginTop:20}}>
        <div className="user-create-heading">
          <span className="eyebrow">AUTORIZZAZIONI</span>
          <b>Permessi del ruolo</b>
          <small>
            {roleForm.permissions.length} di {permissions.length} permessi selezionati
          </small>
        </div>

        <div
          style={{
            display:"grid",
            gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))",
            gap:10,
            marginTop:12
          }}
        >
          {permissions.map(permission=>
            <label
              key={permission.key}
              style={{
                display:"flex",
                gap:10,
                alignItems:"flex-start",
                padding:12,
                border:"1px solid #e5e7eb",
                borderRadius:8,
                cursor:"pointer"
              }}
            >
              <input
                type="checkbox"
                checked={roleForm.permissions.includes(permission.key)}
                disabled={!isRealAdmin && !userPermissions.includes(permission.key)}
                onChange={()=>toggleRolePermission(permission.key)}
              />

              <span>
                <b style={{display:"block"}}>
                  {permission.key}
                </b>

                <small>
                  {permission.description}
                </small>
              </span>
            </label>
          )}
        </div>
      </div>

      {roleError&&
        <div className="error" data-testid="role-error">
          {roleError}
        </div>
      }

      <div className="user-create-actions">
        <button
          type="button"
          onClick={closeRoleForm}
        >
          Annulla
        </button>

        <button
          data-testid="role-submit-button"
          className="primary-btn"
          disabled={savingRole}
          type="submit"
        >
          {savingRole
            ? "Salvataggio…"
            : roleForm.mode==="edit"
              ? "Salva modifiche"
              : "Crea ruolo"}
        </button>
      </div>
    </form>
  }

  {roleMessage&&
    <div className="success" data-testid="role-success">
      {roleMessage}
    </div>
  }

  {roleError&&!roleForm.open&&
    <div className="error" data-testid="role-error-inline">
      {roleError}
    </div>
  }

  <div className="table-wrap">
    <table>
      <thead>
        <tr>
          <th>RUOLO</th>
          <th>CHIAVE</th>
          <th>TIPO</th>
          <th>PERMESSI</th>
          <th>STATO</th>
          <th>AZIONI</th>
        </tr>
      </thead>

      <tbody>

        {roles.length===0&&
          <tr>
            <td colSpan="6" className="empty-row">
              Nessun ruolo disponibile.
            </td>
          </tr>
        }

        {roles.map(role=>
          <tr
            key={role.key}
            data-testid={`admin-role-${role.key}`}
          >
            <td>
              <b>{role.name}</b>
              <small>{role.description||"—"}</small>
            </td>

            <td>
              <span className="role-tag">
                {role.key}
              </span>
            </td>

            <td>
              {role.system
                ? "Sistema"
                : "Personalizzato"}
            </td>

            <td>
              {role.permissions?.length||0}
            </td>

            <td>
              <span
                className={
                  role.active!==false
                    ? "table-status"
                    : "table-status off"
                }
              >
                <i/>
                {role.active!==false
                  ? "Attivo"
                  : "Disattivato"}
              </span>
            </td>

            <td className="row-actions">

              {role.system ? (
  <span style={{fontSize:12,opacity:.65}}>
    Ruolo di sistema
  </span>
) : can("admin.roles.write") ? (
  <>
    <button
      data-testid={`edit-role-${role.key}-button`}
      className="row-btn"
      type="button"
      onClick={()=>openEditRole(role)}
    >
      <Edit2 size={12}/>
      Modifica
    </button>

    {role.key!=="operator"&&(
      <button
        data-testid={`delete-role-${role.key}-button`}
        className="row-btn danger"
        type="button"
        onClick={()=>deleteRole(role)}
      >
        <Trash2 size={12}/>
        Elimina
      </button>
    )}
  </>
) : (
  <span style={{fontSize:12,opacity:.65}}>
    Sola lettura
  </span>
)}

            </td>
          </tr>
        )}

      </tbody>
    </table>
  </div>
</>}
    {section==="audit"&&<>
      <form
        onSubmit={submitAuditSearch}
        data-testid="audit-search-form"
        style={{
          display:"flex",
          alignItems:"flex-end",
          flexWrap:"wrap",
          gap:10,
          marginBottom:18
        }}
      >
        <label style={{flex:"1 1 260px",minWidth:0}}>
          <input
            type="search"
            value={auditSearchInput}
            onChange={e=>setAuditSearchInput(e.target.value)}
            placeholder="Utente, operazione, entità, dettaglio..."
            maxLength={200}
            aria-label="Cerca nel registro Audit"
            data-testid="audit-search-input"
            style={{width:"100%",height:"48px",boxSizing:"border-box"}}
          />
        </label>
        <button
          type="submit"
          className="primary-btn"
          disabled={auditLoading}
          data-testid="audit-search-button"
          style={{height:"48px",boxSizing:"border-box"}}
        >
          Cerca
        </button>
        <button
          type="button"
          onClick={resetAuditSearch}
          disabled={auditLoading}
          data-testid="audit-reset-button"
          style={{
            height:"48px",
            boxSizing:"border-box",
            padding:"10px 16px",
            border:"1px solid #64748b",
            borderRadius:8,
            background:"transparent",
            color:"inherit",
            cursor:auditLoading?"wait":"pointer"
          }}
        >
          Azzera filtri
        </button>
      </form>

      {auditError&&<div className="error" role="alert">{auditError}</div>}

      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>OPERAZIONE</th>
              <th>ENTITÀ</th>
              <th>UTENTE</th>
              <th>DATA</th>
            </tr>
          </thead>
          <tbody>
            {!auditLoading&&!auditError&&audit.length===0&&
              <tr>
                <td colSpan="4" className="empty-row">
                  Nessun evento Audit trovato.
                </td>
              </tr>
            }
            {auditLoading&&
              <tr>
                <td colSpan="4" className="empty-row">
                  Caricamento eventi...
                </td>
              </tr>
            }
            {!auditLoading&&audit.map(a=>
              <tr key={a.id}>
                <td><b>{a.action}</b><small>{a.detail}</small></td>
                <td>{a.entity}</td>
                <td>{a.user}</td>
                <td>{new Date(a.created_at).toLocaleString("it-IT")}</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div
        style={{
          display:"flex",
          alignItems:"center",
          justifyContent:"space-between",
          flexWrap:"wrap",
          gap:12,
          marginTop:16
        }}
      >
        <span style={{fontSize:13,opacity:.8}}>
          Risultati: <b>{auditMeta.total}</b>
          {" · "}Pagina {auditMeta.page} di {auditMeta.pages}
        </span>
        <div style={{display:"flex",gap:8,alignItems:"center"}}>
          <button
            type="button"
            className="row-btn"
            onClick={()=>setAuditPage(p=>Math.max(1,p-1))}
            disabled={auditLoading||auditPage<=1}
            data-testid="audit-previous-button"
          >
            Precedente
          </button>
          <button
            type="button"
            className="row-btn"
            onClick={()=>setAuditPage(p=>Math.min(auditMeta.pages,p+1))}
            disabled={auditLoading||auditPage>=auditMeta.pages}
            data-testid="audit-next-button"
          >
            Successiva
          </button>
        </div>
      </div>
    </>}
  </>;
}
